// Models
PJQ.models.submittals = {};
PJQ.models.submittals.LegacySubmittal = PJQ.models.BaseModel.extend({
	idAttribute: "submittalId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId')
			},
			{
				endpoint: 'submittals',
				value: this.id
			}
		])
	},
	fetchNotifications: function (callback) {
		if (this.notifications == null) {
			this.notifications = new PJQ.collections.submittals.Notifications(null, {
				submittal: this
			})
		}

		this.notifications.fetch({
			success: _.bind(function () {
				callback(this.notifications);
			}, this)
		});
	}
});

PJQ.models.submittals.Notification = PJQ.models.notifications.Notification.extend({
	notificationTypeNames: PJQ.constants.submittals.notificationTypeNames,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'submittals',
				value: this.collection.options.submittal.id
			},
			{
				endpoint: 'notifications',
				value: this.id
			}
		])
	}
});


// Collections
PJQ.collections.submittals = {};
PJQ.collections.submittals.Submittals = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.submittals.Submittal,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'submittals'
			}
		])
	}
});

PJQ.collections.submittals.Notifications = PJQ.collections.notifications.Notifications.extend({
	model: PJQ.models.submittals.Notification,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'submittals',
				value: this.options.submittal.id
			},
			{
				endpoint: 'notifications'
			}
		])
	}
});


var submittalformLastMode = '', submittal = null, submittalFormReadOnly = false, submittalNewComments = [];
var validNumChars = '0123456789';


function CreateSubmittalForm(mode, id) {
	submittalformLastMode = mode;
	if (submittalformLastMode == 'add') {
		PanteraScript.PanteraScriptService.GetSubmittalInfo(pjqSessionId, 0, function (res) {
			CreateSubmittalFormC(jQuery.parseJSON(res));
		}, SubmittalLoadError);
	}
	else {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'v1'
				},
				{
					endpoint: 'projects',
					value: PJQ.app.session.project.id
				},
				{
					endpoint: 'submittals',
					value: parseInt(id)
				},
			]),
			isPascal: true
		}).get().done(_.bind(function (data) {
			CreateSubmittalFormC(data);
		}, this));
	}
}

function SubmittalLoadError(response) {
	if (response._message == "Sequence contains no elements")
		showInfoDialogSubmittal('Submittal Load Error', "An error occurred trying to load this Submittal.  It has been deleted or you may no longer be listed on it.", 'ui-icon-alert');
	else
		showInfoDialogSubmittal('Submittal Load Error', "An error occurred trying to load this Submittal: " + response._message, 'ui-icon-alert');
}


function SubmittalFormEnable(enabled) {
	submittalFormReadOnly = !enabled;

	jQuery('#submittal-fields tr td input[type="text"], #submittal-fields tr td textarea, #submittal-fields tr td select, #submittal-fields tr td div.pjq-choice-field-width input').each(function (index) {
		jQuery(this).prop('disabled', submittalFormReadOnly);

		if (submittalFormReadOnly) {
			if (jQuery(this).attr('type') == 'checkbox')
				jQuery(this).parent().attr('style', 'background-color: #ebebe4 !important;');
			else
				jQuery(this).attr('style', 'background-color: #ebebe4 !important;');
		}
		else {
			if (jQuery(this).attr('type') == 'checkbox')
				jQuery(this).parent().css('background-color', '');
			else
				jQuery(this).css('background-color', '');
		}

		if (jQuery(this).prop('tagName') == 'INPUT' && jQuery(this).hasClass('pjq-date-field-width')) {
			jQuery(this).datepicker(submittalFormReadOnly ? 'disable' : 'enable');
		}
		else if (jQuery(this).prop('tagName') == 'INPUT' && jQuery(this).hasClass('pjq-numeric-field-width')) {
			jQuery(this).spinner(submittalFormReadOnly ? 'disable' : 'enable');
		}

	});


	jQuery('#submittal-save, #submittal-action1').button('option', 'disabled', submittalFormReadOnly);

}

function SubmittalFormEnableAdmin(enabled, container) {
	var isReadOnly = !enabled;
	jQuery(container + ' .submittal-number,' + container + ' .submittal-due-date,' + container + ' .submittal-received-date,' + container + ' .submittal-item-type,' + container + ' .submittal-fields-admin input,' + container + ' .submittal-fields-admin select').prop('disabled', isReadOnly);
	if (isReadOnly)
		jQuery(container + ' .submittal-due-date,' + container + ' .submittal-received-date').attr('style', 'background-color: #ebebe4 !important;');
	else
		jQuery(container + ' .submittal-due-date,' + container + ' .submittal-received-date').css('background-color', '');

	jQuery(container + ' .submittal-due-date,' + container + ' .submittal-received-date').datepicker(isReadOnly ? 'disable' : 'enable');

	jQuery(container + ' .submittal-fields-admin input.pjq-date-field-width').each(function () {
		if (isReadOnly)
			jQuery(this).attr('style', 'background-color: #ebebe4 !important;');
		else
			jQuery(this).css('background-color', '');

		jQuery(this).datepicker(isReadOnly ? 'disable' : 'enable');

	});

	if (isReadOnly || submittal.SubmittalStatus > 1)
		jQuery(container + ' .addSubmittalGroupsButton').hide();
	else
		jQuery(container + ' .addSubmittalGroupsButton').show();
}

function SubmittalFormEnablePeople(enabled, container) {
	if (enabled)
		jQuery(container + ' .addSubmittalAssignedToButton,' + container + ' .addSubmittalApproverListButton,' + container + ' .addSubmittalNotifySubmittedButton,' + container + ' .addSubmittalNotifyRejectedButton,' + container + ' .addSubmittalNotifyApprovedButton').show();
	else
		jQuery(container + ' .addSubmittalAssignedToButton,' + container + ' .addSubmittalApproverListButton,' + container + ' .addSubmittalNotifySubmittedButton,' + container + ' .addSubmittalNotifyRejectedButton,' + container + ' .addSubmittalNotifyApprovedButton').hide();

	if (submittal.IsAdmin)
		jQuery('#submittal-edit-form table tbody tr.submittal-admin-only td').show();
	else
		jQuery('#submittal-edit-form table tbody tr.submittal-admin-only td').hide();

	jQuery(container + ' .addSubmittalAssignedToButton,' + container + ' .addSubmittalApproverListButton,' + container + ' .addSubmittalNotifySubmittedButton,' + container + ' .addSubmittalNotifyRejectedButton,' + container + ' .addSubmittalNotifyApprovedButton').button('option', 'disabled', !enabled);
}

var submittalFormWidth = 0, submittalFilesToolbar = null, submittalFilesGrid = null, submittalDocumentId = 0,
	lastSubmittalEntryId = 0;

function CreateSubmittalFormC(sub) {
	submittal = sub;
	submittalFormReadOnly = false;

	submittalNewComments = [];

	if (window.validator === null) {
		window.validator = jQuery("Form[name='Form']").validate({
			onsubmit: false,
			onkeyup: false,
			showErrors: function (errorMap, errorList) {
				for (var i = 0; errorList[i]; i++) {
					var element = this.errorList[i].element;
					//solves the problem with brute force
					//remove existing error label and thus force plugin to recreate it
					//recreation == call to error placement function
					this.errorsFor(element).remove();
				}
				this.defaultShowErrors();
			},
			errorPlacement: function (error, element) {
				error.html('<br />' + error.text());
				if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
					error.appendTo(element.parent().parent());
				else
					error.appendTo(element.parent());
			},
			errorClass: "pjq-errortext",
			ignore: "pjq-validate-ignore"
		});
	}


	/*
	if (jQuery('#tabsLeft').length > 0)
		submittalFormWidth = (jQuery('#tabsLeft').width() + jQuery('#tabsRight').width() - 12);
	else
		submittalFormWidth = jQuery('#submittal-list-grid').width();
	*/
	submittalFormWidth = 99.8;

	if (SubmittalSubWallCheck()) {
		jQuery('#submittal-edit-form').css('display', 'inline-block');
		jQuery('#tabsLeft').before(jQuery('#submittal-edit-form'));
		jQuery('#leftbar').css('vertical-align', 'top');
		jQuery('#submittal-edit-form').css('border', 'solid 1px black');
		jQuery('#submittal-edit-form').css('padding', '6px');
		jQuery('#submittal-edit-form').css('margin-left', '12px');
		jQuery('#submittal-edit-form').css('width', '70%');
		jQuery('#submittal-edit-form').css('min-width', '920px');
		jQuery('#tabsLeft, #tabsRight').hide();
	}
	else {
		jQuery('#tabsMain').tabs('option', 'disabled', [0, 1, 2, 3, 4, 6, 7, 8]);
		toggleTabs('li-project-submittals', false);
	}
	SubmittalSwitchLeftCommands();

	jQuery('#submittal-header').html(submittalTemplates.submittalHeader.jsRenderTemplate.render());
	if (PJQ.app.module === PJQ.constants.modules.APP) {
		$('.app-commands-submittal').removeClass('hidden');
	}
	else {
		$('.app-commands-submittal').addClass('hidden');
	}
	jQuery('#submittal-header .submittal-commands button, #submittal-save, #submittal-cancel, #submittal-action1, #submittal-action2, #submittal-comment-add').button();

	jQuery('#submittal-comment-add').button('option', 'disabled', true);
	jQuery('#submittal-comment').prop('disabled', true);

	jQuery('#submittal-save').button('option', 'label', 'Save Submittal');

	jQuery('#submittal-action1, #submittal-action2').hide();
	jQuery('#submittal-save').button('option', 'disabled', true);
	if ((submittal.SubmittalStatus == 0 || submittal.SubmittalStatus == 1) && (submittal.IsAdmin || submittal.IsAssignee)) {
		jQuery('#submittal-action1').button('option', 'label', 'Submit Item');
		jQuery('#submittal-action1').prop('action-label', 'Submit');
		jQuery('#submittal-action1').show();
		jQuery('#submittal-unlock').hide();
		jQuery('#submittal-save').button('option', 'disabled', false);
		jQuery('#submittal-comment-add').button('option', 'disabled', false);
		jQuery('#submittal-comment').prop('disabled', false);

	}
	else if ((submittal.SubmittalStatus == 2 || submittal.SubmittalStatus == 3) && (submittal.IsAdmin || submittal.IsApprover)) {
		submittalFormReadOnly = true;
		if (submittal.IsAdmin || submittal.IsApprover) {
			jQuery('#submittal-action1').button('option', 'label', 'Approve Item');
			jQuery('#submittal-action1').prop('action-label', 'Approve');
			jQuery('#submittal-action2').button('option', 'label', 'Reject Item');
			jQuery('#submittal-action2').prop('action-label', 'Reject');
			jQuery('#submittal-action1, #submittal-action2').show();
			jQuery('#submittal-comment-add').button('option', 'disabled', false);
			jQuery('#submittal-comment').prop('disabled', false);
		}
		else {
			jQuery('#submittal-unlock').hide();
		}
		jQuery('#submittal-save').button('option', 'disabled', true);
	}
	else if (submittal.SubmittalStatus == 4) {
		submittalFormReadOnly = true;
		jQuery('#submittal-unlock').hide();
		jQuery('#submittal-save').button('option', 'disabled', false);
		jQuery('#submittal-comment-add').button('option', 'disabled', true);
		jQuery('#submittal-comment').prop('disabled', true);
	}

	if (submittal.SubmittalId == 0) {
		jQuery('#submittal-action1').hide();
		jQuery('#submittal-action2').hide();
	}

	jQuery('#submittal-header .submittal-status').text(submittal.SubmittalStatusDisplay);
	jQuery('#submittal-header .submittal-status').css('color', submittal.SubmittalStatusColor);

	if (submittal.IsGroupsRequired)
		jQuery('#submittal-header .submittalGroupsRequired').text('*');

	if (submittal.SubmittalId == 0) {
		jQuery('#submittal-header button.submittal-history, #submittal-header button.submittal-history-notifications').button('option', 'disabled', true);
		jQuery('#submittal-header button.submittal-export').hide();
		jQuery('#submittal-files-existing').hide();
		jQuery('#submittal-files-new').show();
	}
	else {
		jQuery('#submittal-header button.submittal-history, #submittal-header button.submittal-history-notifications').button('option', 'disabled', false);
		jQuery('#submittal-header button.submittal-export').show();
		jQuery('#submittal-files-existing').show();
		jQuery('#submittal-files-new').hide();
	}

	jQuery('#submittal-header .submittalGroups').text('');

	jQuery('#submittal-comment').val('');
	jQuery('#submittal-comment-grid').html('');

	jQuery('#submittal-header input.submittal-number').val(submittal.SubmittalNumber);

	SubmittalRefreshComments();

	jQuery('#submittal-header .submittalGroupIdList').val(submittal.GroupIdList);
	jQuery('#submittal-header .addSubmittalGroupsButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		var groupIdList = jQuery('#submittal-header .submittalGroupIdList').val();
		initSubmittalGroupsDialog(groupIdList, 'submittalinfo', '#submittal-header');
	});

	jQuery('#submittal-header .submittalAssignedToHidden').val(submittal.AssignedTo);
	jQuery('#submittal-header .addSubmittalAssignedToButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('assignedto', '#submittal-header');
	});

	jQuery('#submittal-header .submittalApproverListHidden').val(submittal.ApproverList);
	jQuery('#submittal-header .addSubmittalApproverListButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('approverlist', '#submittal-header');
	});

	jQuery('#submittal-header .submittalNotifySubmittedListHidden').val(submittal.NotifySubmittedList);
	jQuery('#submittal-header .addSubmittalNotifySubmittedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifysubmittedlist', '#submittal-header');
	});

	jQuery('#submittal-header .submittalNotifyRejectedListHidden').val(submittal.NotifyRejectedList);
	jQuery('#submittal-header .addSubmittalNotifyRejectedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifyrejectedlist', '#submittal-header');
	});

	jQuery('#submittal-header .submittalNotifyApprovedListHidden').val(submittal.NotifyApprovedList);
	jQuery('#submittal-header .addSubmittalNotifyApprovedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifyapprovedlist', '#submittal-header');
	});

	if (submittal.IsAdmin) {
		jQuery('#submittal-header .submittal-item-types').empty();
		for (var i = 0; i < submittal.ItemTypes.length; i++) {
			var checked = submittal.ItemTypes[i].IsSelected ? "checked='checked'" : "";
			var html = "<input type='checkbox' name='itemtype' class='pjq-validate-ignore' submittalitemtype='" + submittal.ItemTypes[i].SubmittalItemTypeId + "' " + checked + " /><label>" + submittal.ItemTypes[i].ItemType + "</label><br />";
			jQuery('#submittal-header .submittal-item-types').append(html);
		}

		// jQuery('#submittal-header .submittal-item-types input').rules('remove');
	}
	else {
		jQuery('#submittal-header .submittal-item-types').html(submittal.ItemTypeDisplay);
		jQuery('#submittal-header button.submittal-history, #submittal-header button.submittal-history-notifications, #submittal-header button.submittal-export').hide();

	}

	jQuery('#submittal-header .submittal-created-by').html(submittal.CreatedByDisplay + ' at ' + submittal.CreatedOn);
	jQuery('#submittal-header .submittal-ball-in-court').html(submittal.BallInCourtDisplay ? submittal.BallInCourtDisplay : "None");
	jQuery('#submittal-header .submittal-ball-in-court-select').hide();
	jQuery('#submittal-header .submittal-ball-in-court').show();

	jQuery('#submittal-header .submittal-due-date, #submittal-header .submittal-received-date').mask('99/99/9999', {
		placeholder: " "
	});

	jQuery('#submittal-header .submittal-due-date, #submittal-header .submittal-received-date').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: function (name, sender) {
			window.validator.element('#' + jQuery(sender).attr('id'));
		}
	});
	jQuery('#submittal-header .submittal-due-date').val(submittal.DueDate);
	jQuery('#submittal-header .submittal-received-date').val(submittal.ReceivedDate);

	if (!submittal.IsAdmin) {
		jQuery('#submittal-header .submittalGroups').text(submittal.GroupListDisplay);

	}

	submittalFilesToolbar = new dhtmlXToolbarObject("submittal-file-toolbar");
	submittalFilesToolbar.setSkin("dhx_web");
	submittalFilesToolbar.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");

	submittalFilesToolbar.addButton('add', 0, 'Upload New Files', "new.gif", "new_dis.gif");

	submittalFilesToolbar.addButton('addv', 1, 'Upload New Version', "new.gif", "new_dis.gif");
	submittalFilesToolbar.disableItem('addv');

	if (!SubmittalSubWallCheck()) {
		submittalFilesToolbar.addButton('delete', 4, 'Delete', "Delete.png", "DeleteD.png");
		submittalFilesToolbar.disableItem('delete');
	}

	submittalFilesToolbar.addButton('download', 5, 'Download', "text_document.gif", "text_documentD.gif");
	submittalFilesToolbar.disableItem('download');

	submittalFilesToolbar.addButton('downloadAll', 6, 'Download All', "text_document.gif", "text_documentD.gif");
	submittalFilesToolbar.disableItem('downloadAll');

	if (SubmittalSubWallCheck() && (submittal.SubmittalStatus > 1 || !submittal.IsAssignee)) {
		submittalFilesToolbar.disableItem('add');
		submittalFilesToolbar.disableItem('addv');
	}
	else if (!SubmittalSubWallCheck() && submittal.SubmittalStatus > 3) {
		submittalFilesToolbar.disableItem('add');
		submittalFilesToolbar.disableItem('addv');
	}


	submittalFilesToolbar.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				parentSubmittalDocumentId = 0;
				PanteraScript.PanteraScriptService.GetNewGuid(CreateSubmittalFilesForm, onScriptError);
				break;
			case 'addv':
				parentSubmittalDocumentId = parseInt(submittalFilesGrid.getUserData(submittalFilesGrid.getSelectedRowId(), 'ParentSubmittalDocumentId'));
				PanteraScript.PanteraScriptService.GetNewGuid(CreateSubmittalFilesForm, onScriptError);
				break;
			case 'delete':
				initSubmittalConfirmDialog('Delete Confirmation', 'Are you sure you want to delete this file?', 'delete-submittal-file');
				break;
			case 'download':
				DownloadSubmittalFile(lastSubmittalEntryId);
				break;
			case 'downloadAll':
				PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: project.ProjectId
					},
					{
						endpoint: 'submittals',
						value: submittal.SubmittalId
					},
					{
						endpoint: 'attachments'
					}
				]));
				break;
		}

	});

	var maxFileCount = undefined;
	var fileTypeFilter = /.+$/i;
	var actionURL =
		PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + submittal.UploadContext + '&sid=' + pjqSessionId;
	jQuery('#submittal-fileupload').fileupload();
	jQuery('#submittal-fileupload').fileupload('option', {
		autoUpload: true,
		maxNumberOfFiles: maxFileCount,
		acceptFileTypes: fileTypeFilter,
		url: actionURL,
		dropZone: jQuery('#submittal-fileupload')
	});
	submittalFilesGrid = new dhtmlXGridObject('submittal-file-grid');
	submittalFilesGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	submittalFilesGrid.setSkin(pjqGridTheme);
	submittalFilesGrid.enableAutoHeight(true);
	submittalFilesGrid.enableAutoWidth();
	submittalFilesGrid.init();
	submittalFilesGrid.attachEvent("onRowSelect", function (id, ind) {


		return SubmittalFileGridRowSelected(id, ind);
	});
	submittalFilesGrid.attachEvent("onSubGridCreated", function (sub_grid_obj, rId, rInd) {
		sub_grid_obj.enableAutoHeight(true);

		submittalDocumentId = parseInt(rId);
		lastSubmittalEntryId = sub_grid_obj.getUserData(rId, 'EntryId');

		if (!SubmittalSubWallCheck() && submittal.SubmittalStatus < 4)
			submittalFilesToolbar.enableItem('delete');

		submittalFilesToolbar.enableItem('download');
		submittalFilesToolbar.disableItem('addv');

		sub_grid_obj.attachEvent("onRowSelect", function (id, ind) {

			submittalFilesGrid.setSelectedRow(rId);
			SubmittalFileGridRowSelected(id, ind);
			return true;
		});

		sub_grid_obj.attachEvent("onRowDblClicked", function (rId, cInd) {
			if (cInd === 0) {
				submittalDocumentId = parseInt(rId);
				lastSubmittalEntryId = sub_grid_obj.getUserData(rId, 'EntryId');
				DownloadSubmittalFile(lastSubmittalEntryId);
			}
			return true;
		});

		return true;
	});

	submittalFilesGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		if (cInd === 1) {
			submittalDocumentId = parseInt(rId);
			lastSubmittalEntryId = submittalFilesGrid.getUserData(rId, 'EntryId');
			DownloadSubmittalFile(lastSubmittalEntryId);
		}
		return true;
	});

	submittalFilesGrid.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		if (stage === 2) {
			if (cInd === 2) {
				PanteraScript.PanteraScriptService.UpdateSubmittalDocumentNotes(pjqSessionId, rId, nValue, null, onScriptError);
			}
		}
		return true;
	});

	submittalFilesGrid.loadXML("/DesktopModules/PJQProjectWallAdmin/GetSubmittalGrid.aspx?sessionid=" + pjqSessionId + '&id=' + submittal.SubmittalId.toString() + '&list=files&x=' + (new Date).getTime(), function () {
		if (submittalFilesGrid.getRowsNum() > 0) {
			submittalFilesToolbar.enableItem('downloadAll');
		}
	});

	jQuery('#submittal-fields tr').each(function (index) {
		jQuery(this).remove();
	});

	jQuery('#submittal-header .submittal-fields-admin tr').each(function (index) {
		if (jQuery(this).hasClass('pjq-custom-field'))
			jQuery(this).remove();
	});

	var template = '';
	template += "<tr class='pjq-custom-field'>";
	template += "       <td class='pjq-field-label' style='width: 15%;'>{{>FieldName}}</td>";
	template += "      {{if IsRequired}}<td class='pjq-label-required' style='width: 8px;'>*</td>{{else}}<td style='width: 8px;'>&nbsp;</td>{{/if}}";
	template += "      <td class='pjq-field-value' submittal-field-type='{{attr:FieldType}}' colspan='2' >";

	template += "{{if FieldType == 'TEXT'}}";
	template += "       <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-default-field-width{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' maxlength='255' />";
	template += "{{else FieldType == 'TEXTAREA'}}";
	template += "       <textarea submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-textarea-field-width {{if IsRequired}} required{{/if}}' >{{attr:FieldValue}}</textarea>";
	template += "{{else FieldType == 'INT'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-numeric-field-width integer{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' maxlength='10'{{if NumericMinValue > 0}} min='{{attr:NumericMinValue}}'{{/if}}{{if NumericMaxValue > 0}}  max='{{attr:NumericMaxValue}}'{{/if}} />";
	template += "{{else FieldType == 'DATE'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-date-field-width{{if IsRequired}} date required{{else}} dateOPT{{/if}}' value='{{>~parseDateDT(FieldValue)}}' maxlength='10' />";
	template += "{{else FieldType == 'DATETIME'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-date-field-width{{if IsRequired}} date required{{else}}{{/if}} pjq-datetime' value='{{>~parseDateDT(FieldValue)}}' maxlength='10' />&nbsp;&nbsp;<input submittalfieldid='submittal-custom2-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-time-field-width {{if IsRequired}} time12h required{{else}} time12hOPT{{/if}}' value='{{>~parseTimeDT(FieldValue)}}' maxlength='8' /><img id='submittal-custom2-tp-{{attr:FieldReportCustomFieldId}}' class='ui-timepicker-trigger' src='/i/icon_scheduler_16px.gif' alt='...' title='...'>";
	template += "{{else FieldType == 'MONEY'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-money-field-width{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' onchange='FormatCurrencyHelper(jQuery(this));' />";
	template += "{{else FieldType == 'BOOL'}}";
	template += "         <select submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-bool-field-width{{if IsRequired}} selectREQ{{/if}}' >";
	template += "          <option value=''>Select Answer...</option>";
	template += "          <option value='true'{{if FieldValue == 'true' || FieldValue == 'Yes'}} selected='selected'{{/if}}>Yes</option>";
	template += "          <option value='false'{{if FieldValue == 'false' || FieldValue == 'No'}} selected='selected'{{/if}}>No</option>";
	template += "         </select>";
	template += "{{else FieldType == 'CHOICE'}}";
	template += " {{if IsChoiceListMultipleChoice}}";
	template += "          <div submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-choice-field-width pjq-multiple-choice-list {{if IsRequired}} pjq-required{{/if}}'  data-choice-list='{{attr:FieldValue}}'>";
	template += " {{for ChoiceList ~FieldReportCustomFieldId=FieldReportCustomFieldId}}";
	template += "          <input type='checkbox' submittalfieldid='submittal-custom-{{>~FieldReportCustomFieldId}}_{{attr:ChoiceId}}' value='{{attr:ChoiceId}}' choice-name='{{attr:ChoiceName}}' />";
	template += "           <label for='submittal-custom-{{attr:FieldReportCustomFieldId}}_{{attr:ChoiceId}}'>{{>ChoiceName}}</label><br />";
	template += " {{/for}}";
	template += "         </div>";
	template += " {{else}}";
	template += "          <select submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-choice-field-width{{if IsRequired}} selectREQ{{/if}}' data-choice-list='{{attr:FieldValue}}' >";
	template += "          <option value=''>Select...</option>";
	template += " {{for ChoiceList}}";
	template += "           <option value='{{attr:ChoiceId}}' text='{{attr:ChoiceName}}' {{if FieldValue && FieldValue.toString().indexOf(ChoiceName)>-1}}selected='selected'{{/if}}>{{>ChoiceName}}</option>";
	template += " {{/for}}";
	template += "          </select>";
	template += " {{/if}}";
	template += "{{/if}}";

	template += "</td></tr>";
	var cfTemplate = $.templates(template);

	var i = 0;
	var vendorFieldCount = 0;
	for (i = 0; i < submittal.CustomFields.length; i++) {

		if (submittal.CustomFields[i].IsEditableNonAdmin) {
			jQuery('#submittal-fields').append(cfTemplate.render(submittal.CustomFields[i]));
			vendorFieldCount++;
		}
		else
			jQuery('#submittal-header .submittal-fields-admin').append(cfTemplate.render(submittal.CustomFields[i]));
	}

	if (vendorFieldCount == 0)
		jQuery('#submittal-fields').hide();
	else
		jQuery('#submittal-fields').show();

	jQuery("#submittal-fields input.pjq-date-field-width, #submittal-header .submittal-fields-admin tr.pjq-custom-field input.pjq-date-field-width").each(function () {
		if (!jQuery(this).hasClass('hasDatepicker')) {
			jQuery(this).mask('99/99/9999', {
				placeholder: " "
			});
			jQuery(this).datepicker({
				showOn: "button",
				numberOfMonths: 3,
				showButtonPanel: true,
				buttonImage: "/i/calendar.png",
				buttonImageOnly: true,
				onSelect: function (name, sender) {
					window.validator.element('#' + jQuery(sender).attr('id'));
				}
			});
		}
	});

	jQuery("#submittal-fields input.pjq-time-field-width, #submittal-header .submittal-fields-admin tr.pjq-custom-field input.pjq-time-field-width").each(function () {
		if (!jQuery(this).hasClass('hasTimepicker')) {
			jQuery(this).timepicker({
				showOn: 'button',
				showPeriod: true,
				button: jQuery(this).siblings('.ui-timepicker-trigger'),
				onSelect: function (name, sender) {
					window.validator.element('#' + jQuery(sender).attr('id'));
				}
			});
		}
	});

	jQuery("#submittal-fields input.pjq-numeric-field-width, #submittal-header .submittal-fields-admin tr.pjq-custom-field input.pjq-numeric-field-width").each(function () {
		var minVal = 0;
		if (jQuery(this).attr('min'))
			minVal = parseInt(jQuery(this).attr('min'));
		var maxVal = 2147483647;
		if (jQuery(this).attr('max'))
			maxVal = parseInt(jQuery(this).attr('max'));
		jQuery(this).spinner({
			min: minVal,
			max: maxVal,
			step: 1,
			spin: function (event, ui) {
				window.validator.element('#' + jQuery(this).attr('id'));
				//EnableSave();
			}
		});
	});

	jQuery("#submittal-fields select.pjq-choice-field-width, #submittal-header .submittal-fields-admin tr.pjq-custom-field select.pjq-choice-field-width").each(function () {
		var x = jQuery(this).attr('data-choice-list').split('|||');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			//jQuery(this).find("option[value='"+x[i].trim()+"'], option[text='"+x[i].trim()+"']").attr('selected','selected');
			jQuery(this).find("option[value='" + x[i].trim() + "'], option[text='" + x[i].trim() + "']").prop('selected', true);
			//jQuery(this).find("option[text='"+x[i].trim()+"']").attr('selected','selected');
			jQuery(this).find("option[text='" + x[i].trim() + "']").prop('selected', true);
		}
	});

	jQuery("#submittal-fields div.pjq-multiple-choice-list, #submittal-header .submittal-fields-admin tr.pjq-custom-field div.pjq-multiple-choice-list").each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("input[value='" + x[i].trim() + "']").prop('checked', true);
		}
	});

	jQuery("#submittal-fields input.pjq-money-field-width, #submittal-header .submittal-fields-admin tr.pjq-custom-field input.pjq-money-field-width").each(function () {
		FormatCurrencyHelper(jQuery(this));
	});

	PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, submittal.AssignedTo.toString(), project.ProjectId, 'assignedto|#submittal-header', GetSubmittalContactInfoC, onScriptError);
	PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, submittal.ApproverList, project.ProjectId, 'approverlist|#submittal-header', GetSubmittalContactInfoC, onScriptError);
	PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, submittal.NotifySubmittedList, project.ProjectId, 'notifysubmittedlist|#submittal-header', GetSubmittalContactInfoC, onScriptError);
	PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, submittal.NotifyRejectedList, project.ProjectId, 'notifyrejectedlist|#submittal-header', GetSubmittalContactInfoC, onScriptError);
	PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, submittal.NotifyApprovedList, project.ProjectId, 'notifyapprovedlist|#submittal-header', GetSubmittalContactInfoC, onScriptError);

	if (submittal.IsAdmin)
		initSubmittalGroupsTree(true, 'submittalinfo', false, '#submittal-header');

	// core fields not editable once submitted, no matter what.
	SubmittalFormEnable(submittal.SubmittalStatus < 3 && (submittal.IsAdmin || submittal.IsAssignee));

	// check Readonly status depending on form state.
	SubmittalFormEnableAdmin(submittal.IsAdmin && submittal.SubmittalStatus < 4, '#submittal-header');

	if (submittal.IsSubmittalNumberFormat)
		jQuery('#submittal-header .submittal-number').removeClass('required');
	else if (!jQuery('#submittal-header .submittal-number').hasClass('required'))
		jQuery('#submittal-header .submittal-number').addClass('required');

	if (submittal.SubmittalStatus > 0)
		jQuery('#submittal-header .submittal-number').prop('disabled', true);
	else if (submittal.IsAdmin)
		jQuery('#submittal-header .submittal-number').prop('disabled', false);

	var enablePeople = (submittal.IsAdmin && submittal.SubmittalStatus < 3);
	if (settings.AllowSubmittalPeopleEditAfterSubmit && submittal.IsAdmin && submittal.SubmittalStatus < 4) {
		enablePeople = true;
		jQuery('#submittal-save').button('option', 'disabled', false);
	}

	SubmittalFormEnablePeople(enablePeople, "#submittal-header");

	// if approver, enable approve/reject buttons.
	if (submittal.SubmittalStatus < 2 && ((!submittal.IsApprover && submittal.IsBallInCourt) || submittal.IsAdmin)) {
		jQuery('#submittal-action1').button('option', 'disabled', false);

		if (submittal.SubmittalId > 0)
			jQuery('#submittal-action1').show();
		else
			jQuery('#submittal-action1').hide();
	}
	else if (submittal.SubmittalStatus == 2 || submittal.SubmittalStatus == 3) {
		if ((submittal.IsApprover && (submittal.IsBallInCourt || submittal.ApprovalMode == 2)) || submittal.IsAdmin)
			jQuery('#submittal-action1, #submittal-action2').button('option', 'disabled', false);
		else
			jQuery('#submittal-action1, #submittal-action2').button('option', 'disabled', true);
	}
	else
		jQuery('#submittal-action1, #submittal-action2').button('option', 'disabled', false);

	jQuery('#submittal-list-container').hide();
	jQuery('#submittal-edit-form').show();

	if (typeof submittalsOnLoad === 'function')
		submittalsOnLoad();
}


function SubmittalFileGridRowSelected(id, ind) {
	submittalDocumentId = parseInt(id);
	lastSubmittalEntryId = submittalFilesGrid.getUserData(id, 'EntryId');

	if (!SubmittalSubWallCheck() && submittal.SubmittalStatus < 4)
		submittalFilesToolbar.enableItem('delete');

	submittalFilesToolbar.enableItem('download');

	var selectedId = submittalFilesGrid.getSelectedRowId();

	if (selectedId.indexOf(',') == -1)
		submittalFilesToolbar.enableItem('addv');
	else
		submittalFilesToolbar.disableItem('addv');

	if (SubmittalSubWallCheck() && submittal.SubmittalStatus > 1) {
		submittalFilesToolbar.disableItem('addv');
	}
	else if (!SubmittalSubWallCheck() && submittal.SubmittalStatus > 3) {
		submittalFilesToolbar.disableItem('addv');
	}

	if (submittal.IsApprover && submittal.SubmittalStatus < 4)
		submittalFilesToolbar.enableItem('addv');

	return true;
}

function SubmittalFormAction(which) {
	if (!ValidateSubmittal())
		return;

	var action = 'formaction' + which.toString();
	var actionLabel = jQuery('#submittal-action' + which.toString()).prop('action-label');

	var html = '<table class="pjq-editable-table" cellspacing="6">';

	html += '<tr><td class="pjq-field-label">Comment<br />(optional)</td><td><textarea id="submittal-formaction-comment" style="width:100%; height:200px;" /></td></tr>';

	if (submittal.IsAdmin)
		html += '<tr><td class="pjq-field-label">Due Date</td><td><input id="submittal-formaction-duedate" class="pjq-date-field-width" /></td></tr>';
	else
		html += '<tr style="pjq-hidden"><td class="pjq-field-label pjq-hidden">Due Date</td><td class="pjq-hidden"><input id="submittal-formaction-duedate" class="pjq-date-field-width pjq-hidden" /></td></tr>';

	html += '</table>';

	var question = 'Are you sure you want to ' + actionLabel + ' this Submittal?';
	if (!submittal.IsBallInCourt)
		question += ' Note that the Ball In Court is set to someone else.';

	question = "<div class='highlightNote' style='padding: 8px;'>" + question + "</div>";

	initSubmittalConfirmDialog('Confirm Action', question + html, action, which);
}

function SubmittalFormAction1(comment, dueDate) {
	// if new/unapproved, set back to submitted
	if (submittal.SubmittalStatus == 0 || submittal.SubmittalStatus == 1) {
		SubmittalSave(true, 2, comment, dueDate);
	}
	else if (submittal.SubmittalStatus == 2 || submittal.SubmittalStatus == 3) {
		// approval list logic
		SubmittalSave(true, 4, comment, dueDate);
	}
}

function SubmittalFormAction2(comment, dueDate) {
	// if submitted, set back to unapproved
	if (submittal.SubmittalStatus == 2 || submittal.SubmittalStatus == 3) {
		SubmittalSave(true, 1, comment, dueDate);
	}
}


function SubmittalSaveButton(validate, newStatus) {

	if (jQuery('#submittal-batch-add-form').is(':visible')) {

		var batchRows = jQuery('#submittal-batch-add-form div.submittal-batch-row');
		var hasErrors = false;
		for (var i = 0; i < batchRows.length; i++) {
			if (!ValidateSubmittalAdmin('#' + jQuery(batchRows[i]).attr('id')))
				hasErrors = true;
		}

		if (!hasErrors)
			SubmittalSaveBatch();
	}
	else
		SubmittalSave(false);
}

function ValidateSubmittalAdmin(container) {
	var submittalErrors = 0;
	if (!window.validator.element(container + ' .submittal-number')) {
		jQuery(container + ' .submittal-number').focus();
		submittalErrors++;
	}

	var itemTypeCheckboxes = jQuery(container + ' .submittal-item-types input');
	var itemTypes = [];
	for (var i = 0; i < itemTypeCheckboxes.length; i++) {
		if (jQuery(itemTypeCheckboxes[i]).prop('checked')) {
			var itemTypeId = jQuery(itemTypeCheckboxes[i]).attr('submittalitemtype').substring(jQuery(itemTypeCheckboxes[i]).attr('submittalitemtype').lastIndexOf('_') + 1);
			itemTypes.push(itemTypeId);
		}
	}

	jQuery(container + ' .submittal-item-types').removeClass('pjq-errortext');
	jQuery(container + ' .submittal-item-types').parent().find('label.pjq-errortext').remove();
	if (itemTypes.length == 0) {
		jQuery(itemTypeCheckboxes[0]).focus();

		submittalErrors++;
		jQuery(container + ' .submittal-item-types').parent().append("<label for='.submittal-item-types' class='pjq-errortext'>Please check at least one selection.</label>");
		jQuery(container + ' .submittal-item-types').addClass('pjq-errortext');
	}

	jQuery(container + ' .submittal-ball-in-court-select').removeClass('pjq-errortext');
	jQuery(container + ' .submittal-ball-in-court-select').parent().find('label.pjq-errortext').remove();
	if (jQuery(container + ' .submittal-ball-in-court-select').is(':visible') && jQuery(container + ' .submittal-ball-in-court-select').val() == '') {
		jQuery(container + ' .submittal-ball-in-court-select').focus();

		submittalErrors++;
		jQuery(container + ' .submittal-ball-in-court-select').parent().append("<label for='.submittal-ball-in-court-select' class='pjq-errortext'>Please select Ball In Court person.</label>");
		jQuery(container + ' .submittal-ball-in-court-select').addClass('pjq-errortext');
	}

	if (!window.validator.element(container + ' .submittal-due-date')) {
		jQuery(container + ' .submittal-due-date').focus();
		submittalErrors++;
	}

	if (!window.validator.element(container + ' .submittal-received-date')) {
		jQuery(container + ' .submittal-received-date').focus();
		submittalErrors++;
	}

	var groupIdList = jQuery(container + ' .submittalGroupIdList').val();
	if (!groupIdList && submittal.IsGroupsRequired) {
		jQuery(container + ' .submittalGroups').focus();
		submittalErrors++;
		if (jQuery(container + ' .submittalGroups').html().indexOf('pjq-errortext') == -1)
			jQuery(container + ' .submittalGroups').html("None<br /><label for='.submittalGroups' class='pjq-errortext'>Please select " + settings.GroupLabel + ".</label>");
	}

	var tempList = jQuery(container + ' .submittalAssignedToHidden').val();
	if (!tempList || tempList == 0) {
		jQuery(container + ' .submittalAssignedTo').focus();
		submittalErrors++;
		if (jQuery(container + ' .submittalAssignedTo').html().indexOf('pjq-errortext') == -1)
			jQuery(container + ' .submittalAssignedTo').html("None<br /><label for='.submittalAssignedTo' class='pjq-errortext'>Please select an Assignee.</label>");
	}


	tempList = jQuery(container + ' .submittalApproverListHidden').val();
	if (!tempList) {
		jQuery(container + ' .submittalApproverList').focus();
		submittalErrors++;
		if (jQuery(container + ' .submittalApproverList').html().indexOf('pjq-errortext') == -1)
			jQuery(container + ' .submittalApproverList').html("None<br /><label for='.submittalApproverList' class='pjq-errortext'>Please select at least one Approver.</label>");
	}

	var whichFields = container + " .submittal-fields-admin tbody tr.pjq-custom-field td input[type='text']," + container + " .submittal-fields-admin tbody tr.pjq-custom-field td input.date," + container + " .submittal-fields-admin tbody tr.pjq-custom-field td span input," + container + " .submittal-fields-admin tbody tr.pjq-custom-field td select," + container + " .submittal-fields-admin tbody tr.pjq-custom-field td div," + container + " .submittal-fields-admin tbody tr.pjq-custom-field td input.pjq-money-field-width," + container + " .submittal-fields-admin tbody tr.pjq-custom-field td textarea.pjq-textarea-field-width";

	jQuery(whichFields).each(function (index) {
		var id = jQuery(this).attr('submittalfieldid');

		if (jQuery(this).prop('tagName') == 'DIV' && jQuery(this).hasClass('pjq-choice-field-width')) {

			var checkboxes = jQuery('input', jQuery(this));
			var checkedIdList = [], i = 0;
			for (i = 0; i < checkboxes.length; i++) {
				if (jQuery(checkboxes[i]).prop('checked')) {
					var choiceId = jQuery(checkboxes[i]).attr('submittalfieldid').substring(jQuery(checkboxes[i]).attr('submittalfieldid').lastIndexOf('_') + 1);

					checkedIdList.push(choiceId);

				}
			}

			if (jQuery(this).hasClass('pjq-required') && checkedIdList.length == 0) {
				submittalErrors++;

				jQuery(this).parent().append("<label for='" + jQuery(this).attr('submittalfieldid') + "' class='pjq-errortext'>Please check at least one selection.</label>");
				jQuery(this).addClass('pjq-errortext');
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		else {
			if (!window.validator.element(this)) {
				submittalErrors++;
			}
		}
	});

	return (submittalErrors == 0);

}

function ValidateSubmittal() {
	var submittalErrors = 0;

	var whichFields = "#submittal-fields tbody tr td input[type='text'],#submittal-fields tbody tr td input.date, #submittal-fields tbody tr td span input, #submittal-fields tbody tr td select, #submittal-fields tbody tr td div, #submittal-fields tbody tr td input.pjq-money-field-width, #submittal-fields tbody tr td textarea.pjq-textarea-field-width";

	jQuery(whichFields).each(function (index) {
		var id = jQuery(this).attr('submittalfieldid');

		if (jQuery(this).prop('tagName') == 'DIV' && jQuery(this).hasClass('pjq-choice-field-width')) {

			var checkboxes = jQuery('input', jQuery(this));
			var checkedIdList = [], i = 0;
			for (i = 0; i < checkboxes.length; i++) {
				if (jQuery(checkboxes[i]).prop('checked')) {
					var choiceId = jQuery(checkboxes[i]).attr('submittalfieldid').substring(jQuery(checkboxes[i]).attr('submittalfieldid').lastIndexOf('_') + 1);

					checkedIdList.push(choiceId);

				}
			}

			if (jQuery(this).hasClass('pjq-required') && checkedIdList.length == 0) {
				submittalErrors++;

				jQuery(this).parent().append("<label for='" + jQuery(this).attr('submittalfieldid') + "' class='pjq-errortext'>Please check at least one selection.</label>");
				jQuery(this).addClass('pjq-errortext');
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		else {
			if (!window.validator.element(this))
				submittalErrors++;

		}
	});

	return (submittalErrors == 0);
}

var submittalCustomFieldList = '',
	itemTypes = [],
	dueDate = '';
var newStatusComment = '';

function SubmittalSave(validate, newStatus, newComment, newDueDate) {
	var submittalErrors = 0;
	newStatusComment = newComment;
	var itemTypeCheckboxes = jQuery('#submittal-header .submittal-item-types input');
	itemTypes = [];
	for (var i = 0; i < itemTypeCheckboxes.length; i++) {
		if (jQuery(itemTypeCheckboxes[i]).prop('checked')) {
			var itemTypeId = jQuery(itemTypeCheckboxes[i]).attr('submittalitemtype').substring(jQuery(itemTypeCheckboxes[i]).attr('submittalitemtype').lastIndexOf('_') + 1);
			itemTypes.push(itemTypeId);
		}
	}

	if (submittal.IsAdmin) {
		if (!ValidateSubmittalAdmin('#submittal-header'))
			submittalErrors++;
	}

	if (validate) {
		if (!ValidateSubmittal())
			submittalErrors++;
	}

	if (submittalErrors > 0)
		return;

	submittalCustomFieldList = '';
	var whichFields = "#submittal-fields tbody tr td input[type='text'],#submittal-fields tbody tr td input.date, #submittal-fields tbody tr td span input, #submittal-fields tbody tr td select, #submittal-fields tbody tr td div, #submittal-fields tbody tr td input.pjq-money-field-width, #submittal-fields tbody tr td textarea.pjq-textarea-field-width";
	if (submittal.IsAdmin)
		whichFields += ",#submittal-header .submittal-fields-admin tbody tr.pjq-custom-field td input[type='text'],#submittal-header .submittal-fields-admin tbody tr.pjq-custom-field td input.date, #submittal-header .submittal-fields-admin tbody tr.pjq-custom-field td span input, #submittal-header .submittal-fields-admin tbody tr.pjq-custom-field td select, #submittal-header .submittal-fields-admin tbody tr.pjq-custom-field td div, #submittal-header .submittal-fields-admin tbody tr.pjq-custom-field td input.pjq-money-field-width, #submittal-header .submittal-fields-admin tbody tr.pjq-custom-field td textarea.pjq-textarea-field-width";

	jQuery(whichFields).each(function () {
		var fieldId = jQuery(this).attr('submittalfieldid').substring(jQuery(this).attr('submittalfieldid').lastIndexOf('-') + 1);

		if (jQuery(this).prop('tagName') == 'SELECT') {
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}';
			jQuery('option:selected', jQuery(this)).each(function () {
				submittalCustomFieldList = submittalCustomFieldList + jQuery(this).val() + ',';
			});
			if (submittalCustomFieldList.substring(submittalCustomFieldList.length - 1) == ',')
				submittalCustomFieldList = submittalCustomFieldList.substring(0, submittalCustomFieldList.length - 1);
			submittalCustomFieldList = submittalCustomFieldList + '||||';
		}
		else if (jQuery(this).hasClass('pjq-money-field-width')) {
			var money = jQuery(this).val();
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + money + '||||';
		}
		else if (jQuery(this).hasClass('pjq-textarea-field-width')) {
			var textarea = jQuery(this).val();
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + textarea + '||||';
		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}';
			jQuery("input[type='checkbox']:checked", this).each(function () {
				submittalCustomFieldList = submittalCustomFieldList + jQuery(this).val() + ',';
			});
			if (submittalCustomFieldList.substring(submittalCustomFieldList.length - 1) == ',')
				submittalCustomFieldList = submittalCustomFieldList.substring(0, submittalCustomFieldList.length - 1);
			submittalCustomFieldList = submittalCustomFieldList + '||||';
		}
		else if (jQuery(this).hasClass('pjq-datetime')) {
			// ignore, it will get picked up by the time field below this case.
		}
		else if (jQuery(this).hasClass('pjq-time-field-width')) {
			var dtvalue = jQuery(this).siblings('.pjq-date-field-width').val() + ' ' + jQuery(this).val();
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + dtvalue.trim() + '||||';
		}
		else {
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + jQuery(this).val() + '||||';
		}
	});
	if (submittalCustomFieldList.length > 0)
		submittalCustomFieldList = submittalCustomFieldList.substring(0, submittalCustomFieldList.length - 4);

	if (newStatus) {
		submittal.SubmittalStatus = newStatus;
		//if (newStatus > 1)
		//    fieldReport.RejectionReason = '';
	}

	dueDate = jQuery('#submittal-header .submittal-due-date').val();
	if (newDueDate)
		dueDate = newDueDate;

	//if (newComment)
	//    submittalNewComments.push(newComment);

	if (submittal.IsAdmin) {
		var saveAssignedTo = parseInt(jQuery('#submittal-header .submittalAssignedToHidden').val());
		var isAdminOverride = jQuery('#submittal-header .submittal-ball-in-court-select').is(':visible');
		var saveApproverList = jQuery('#submittal-header .submittalApproverListHidden').val(),
			approverArr = saveApproverList.split(','),
			hasNewApprovers = false,
			hasAdminOverridden = false;

		if (submittal != null) {
			if (isAdminOverride) {

				if (submittal.BallInCourt != parseInt(jQuery('#submittal-header .submittal-ball-in-court-select').val()))
					hasAdminOverridden = true;

				if (submittal.ApproverList != saveApproverList)
					hasAdminOverridden = true;

				// compare existing approver list / ball in court to new and warn if any approvers have been 'skipped'.
				if (saveAssignedTo == jQuery('#submittal-header .submittal-ball-in-court-select').val()) {
					// if the user reset the ball in court to the assignee, then the status must become 'new'
					// assignee is ball in court so don't need to worry about new approver lists
					submittal.SubmittalStatus = 0;
				}
				else if (hasAdminOverridden) {
					var existingApprovers = submittal.ApproverList.split(',');
					var existingApproved = [];

					// build list of who has already approved
					if (submittal.ApproverList.indexOf(submittal.BallInCourt.toString()) != -1) {
						for (var i = 0; i < existingApprovers.length; i++) {
							if (existingApprovers[i] == submittal.BallInCourt.toString())
								break;

							existingApproved.push(existingApprovers[i]);
						}
					}

					// build list of who should have already approved (by being before current ball in court)
					var deleteList = [];
					var deleteNameList = [];
					var approverNames = jQuery('div.submittalApproverList > div');
					for (var i = 0; i < approverArr.length; i++) {

						// if we're on ball in court, time to exit loop
						if (approverArr[i] == jQuery('#submittal-header .submittal-ball-in-court-select').val())
							break;

						// if this approver hasn't already approved
						if (jQuery.inArray(approverArr[i], existingApproved) == -1) {
							deleteList.push(approverArr[i]);
							var label = jQuery(approverNames[i]).text();
							label = label.substring(label.indexOf(')') + 1);
							deleteNameList.push(label);
						}
					}

					if (deleteList.length > 0) {
						initSubmittalConfirmDialog('Approval List Error', 'The following Approvers have been inserted before the current Ball In Court, but have never approved:<br />' + deleteNameList.join('<br />') + '<br /><br />Do you want to remove these Approvers and Save?', 'deleteInappopriateApprovers', deleteList);
						return;
					}
				}

				// ball in court is whatever the user says it is
				submittal.BallInCourt = parseInt(jQuery('#submittal-header .submittal-ball-in-court-select').val());

			}
			else {
				// standard biz logic
				if (saveAssignedTo != submittal.AssignedTo && submittal.AssignedTo > 0) {

					if (submittal.SubmittalStatus > 0)
						submittal.SubmittalStatus = 0;

					submittal.BallInCourt = saveAssignedTo;
				}

				if (saveApproverList.length > 0) {
					var existingApproverArr = submittal.ApproverList.split(',');
					for (var i = 0; i < approverArr.length; i++) {
						if (existingApproverArr.indexOf(approverArr[i]) == -1) {
							hasNewApprovers = true;
							break;
						}
					}

					if (hasNewApprovers && submittal.SubmittalStatus > 1) {
						PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, saveApproverList, project.ProjectId, 'approverlist|#submittal-header', ShowBallInCourtChooserDialog, onScriptError);
						return;
					}
				}
			}
		}
		AddUpdateSubmittal();
	}
	else {
		ShowBusy('Saving...');
		PanteraScript.PanteraScriptService.AddUpdateSubmittal(pjqSessionId, submittal.SubmittalId, submittal.SubmittalStatus, submittal.UploadContext, submittalCustomFieldList, (typeof newComment == 'undefined' ? null : newComment), AddUpdateSubmittalC, onScriptError);
	}
}

function ShowBallInCourtChooserDialog(response) {
	var contacts = JSON.parse(response);
	jQuery('#newBallInCourtChooser').empty();
	for (var i = 0; i < contacts.ContactList.length; i++) {
		jQuery('#newBallInCourtChooser').append('<option approver-id="' + contacts.ContactList[i].Id + '">' + contacts.ContactList[i].Name + '</option>');
	}

	jQuery('#submittal-ball-in-court-chooser-dialog').dialog({
		title: 'Select New Ball In Court',
		modal: true,
		resizable: false,
		dialogClass: 'submittal-ball-in-court-chooser-dialog',
		closeOnEscape: false,
		width: 250,
		height: 150,
		position: 'top',
		open: function (e, ui) {
			jQuery(".submittalBallInCourtChooser .ui-dialog-titlebar-close").hide();
			jQuery('#setBallInCourtButton').button();
			jQuery('#setBallInCourtButton').off();
			jQuery('#setBallInCourtButton').on('click', function () {
				submittal.BallInCourt = parseInt(jQuery('#newBallInCourtChooser').find(':selected').attr('approver-id'));
				AddUpdateSubmittal();
				jQuery('#submittal-ball-in-court-chooser-dialog').dialog('close');
			});
		}
	})
}

function AddUpdateSubmittal() {

	if (submittal.IsAdmin && !SubmittalSubWallCheck() && settings.UserSeatLimit && settings.UserSeatLimit > 0) {
		// build contactidlist
		var contactIdList = [];
		if (jQuery('#submittal-header .submittalAssignedToHidden').val().length > 0)
			contactIdList.push(jQuery('#submittal-header .submittalAssignedToHidden').val());

		if (jQuery('#submittal-header .submittalApproverListHidden').val().length > 0)
			contactIdList.push(jQuery('#submittal-header .submittalApproverListHidden').val());

		if (jQuery('#submittal-header .submittalNotifySubmittedListHidden').val().length > 0)
			contactIdList.push(jQuery('#submittal-header .submittalNotifySubmittedListHidden').val());

		if (jQuery('#submittal-header .submittalNotifyApprovedListHidden').val().length > 0)
			contactIdList.push(jQuery('#submittal-header .submittalNotifyApprovedListHidden').val());

		if (jQuery('#submittal-header .submittalNotifyRejectedListHidden').val().length > 0)
			contactIdList.push(jQuery('#submittal-header .submittalNotifyRejectedListHidden').val());

		// check it
		InitializeSeatCheckGrid(contactIdList.join(','), AddUpdateSubmittal2);
	}
	else
		AddUpdateSubmittal2();
}

function AddUpdateSubmittal2() {

	ShowBusy('Saving...');
	var assignedTo = parseInt(jQuery('#submittal-header .submittalAssignedToHidden').val());
	var approverList = jQuery('#submittal-header .submittalApproverListHidden').val();
	var groupIdList = jQuery('#submittal-header .submittalGroupIdList').val();
	var notifySubmittedList = jQuery('#submittal-header .submittalNotifySubmittedListHidden').val();
	var notifyApprovedList = jQuery('#submittal-header .submittalNotifyApprovedListHidden').val();
	var notifyRejectedList = jQuery('#submittal-header .submittalNotifyRejectedListHidden').val();

	PanteraScript.PanteraScriptService.AddUpdateSubmittalAdmin(pjqSessionId, submittal.SubmittalId, jQuery('#submittal-header .submittal-number').val(), itemTypes.join(','), groupIdList, assignedTo, submittal.BallInCourt, approverList, dueDate, jQuery('#submittal-header .submittal-received-date').val(), submittal.SubmittalStatus, submittal.NotifyNewList, notifySubmittedList, notifyRejectedList, notifyApprovedList, submittal.UploadContext, submittalCustomFieldList, (typeof newStatusComment == 'undefined' ? null : newStatusComment), AddUpdateSubmittalC, onScriptError);
}

function AddUpdateSubmittalC(response) {
	HideBusy();
	if (submittalNewComments && submittalNewComments.length > 0) {
		for (var i = 0; i < submittalNewComments.length; i++)
			PanteraScript.PanteraScriptService.AddComment(pjqSessionId, "Submittal", parseInt(response), submittalNewComments[i], null, onScriptError);
	}
	submittalNewComments = [];
	SubmittalCancelButton();
	ReloadSubmittalList();
}

var lastSubmittalEntryId = null;

function SubmittalFileDelete(sender, id) {
	var containerId = jQuery(sender).closest("div.frform-file").attr('id');
	lastSubmittalEntryId = containerId.substring(containerId.lastIndexOf('-') + 1);


	initSubmittalConfirmDialog('Confirm File Deletion', 'Are you sure you want to delete this file?', 'deleteSubmittalFile', id);
}


function SubmittalCancelButton() {
	submittal = null;
	//frForm.dialog('close');
	jQuery('#submittal-edit-form').hide();
	jQuery('#submittal-batch-add-form').hide();
	jQuery('#submittal-list-container').show();

	if (SubmittalSubWallCheck()) {
		jQuery('#tabsLeft, #tabsRight').show();
		jQuery('#tabsRight ul').find('li').each(function (index) {
			if (jQuery(this).attr('id') != null && 'li-submittal' == jQuery(this).attr('id').toLowerCase()) {
				jQuery(this).find('a').trigger('click');
				jQuery('#tabsRight').tabs('option', 'active', index);
				return false;
			}
		});
	}
	else {
		toggleTabs('', true);
	}
	SubmittalEnableLeftCommands();
}

/* People Chooser */
var submittalChooserMode = '', isSubmittalChooserGridInit = null, submittalChooserGrid = null,
	submittalChooserGridTb = null;

function initSubmittalProjectContactsDialog(mode, container) {
	var dialogTitle = '';
	if (mode == 'assignedto') {
		dialogTitle = 'Set Assigned To';
	}
	else if (mode == 'approverlist') {
		dialogTitle = 'Add to Approver List';
	}
	else if (mode == 'notifysubmittedlist') {
		dialogTitle = 'Add to Notifications (Submitted)';
	}
	else if (mode == 'notifyrejectedlist') {
		dialogTitle = 'Add to Notifications (Rejected)';
	}
	else if (mode == 'notifyapprovedlist') {
		dialogTitle = 'Add to Notifications (Approved)';
	}

	submittalChooserMode = mode;

	var selectedIds = [];
	if (submittalChooserMode == 'approverlist')
		selectedIds = jQuery(container + ' .submittalApproverListHidden').val().toString().split(',');
	else if (submittalChooserMode == 'notifysubmittedlist')
		selectedIds = jQuery(container + ' .submittalNotifySubmittedListHidden').val().toString().split(',');
	else if (submittalChooserMode == 'notifyrejectedlist')
		selectedIds = jQuery(container + ' .submittalNotifyRejectedListHidden').val().toString().split(',');
	else if (submittalChooserMode == 'notifyapprovedlist')
		selectedIds = jQuery(container + ' .submittalNotifyApprovedListHidden').val().toString().split(',');

	if (selectedIds.length == 1 && (selectedIds[0].length == 0 || selectedIds[0] == "0"))
		selectedIds = [];

	if (submittalChooserGrid)
		submittalChooserGrid = null;
	if (submittalChooserGridTb)
		submittalChooserGridTb = null;
	jQuery('div.submittalChooserDialog').remove();

	jQuery('#submittalChooserDialog').dialog({
		title: dialogTitle,
		modal: true,
		resizable: false,
		dialogClass: 'submittalChooserDialog',
		width: 700,
		position: 'top',
		open: function (e, ui) {
			//if (isSubmittalChooserGridInit) {
			//    submittalChooserGrid.loadXML(getGridURLSubmittalChooser());
			//    submittalChooserGridTb.disableItem('add');
			//} else {
			jQuery('#isShowITBSubmittal').on('change', function () {
				submittalChooserGrid.loadXML(getGridURLSubmittalChooser());
			});
			isSubmittalChooserGridInit = true;
			submittalChooserGrid = new dhtmlXGridObject('submittalChooserGrid');
			submittalChooserGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
			submittalChooserGrid.setSkin(pjqGridTheme);
			submittalChooserGrid.enableAutoHeight(true);
			submittalChooserGrid.enablePaging(true, 10, 3, "submittalChooserGridPaging", true);
			submittalChooserGrid.setPagingSkin("toolbar", "dhx_web");
			submittalChooserGrid.setDragBehavior('complex');
			submittalChooserGrid.setDelimiter('|');
			submittalChooserGrid.loadXML(getGridURLSubmittalChooser());
			submittalChooserGrid.init();
			submittalChooserGrid.attachEvent("onXLE", function (grid_obj, count) {
				submittalChooserGrid.setSizes();

				//for (var i = 0; i < existingList.length; i++) {
				//    if (submittalChooserGrid.getRowIndex(existingList[i]) != -1) {
				//        submittalChooserGrid.cells(existingList[i], 0).setValue(1);
				//    }

				//    submittalChooserGrid.setSizes();
				//}
			});
			submittalChooserGrid.attachEvent("onCheck", function (id, ind, state) {

				var tempCheckedRows = submittalChooserGrid.getCheckedRows(0).split(',');

				if (submittalChooserMode == 'assignedto') {
					for (var i = 0; i < tempCheckedRows.length; i++) {
						if (tempCheckedRows[i] && !submittalChooserGrid.cells(tempCheckedRows[i], 0).cell._disabled && parseInt(tempCheckedRows[i]) != parseInt(id)) {
							submittalChooserGrid.cells(tempCheckedRows[i], 0).setValue(0);
						}
					}
					tempCheckedRows = submittalChooserGrid.getCheckedRows(0).split(',');
				}

				var checkedRows = [];
				for (var i = 0; i < tempCheckedRows.length; i++) {
					if (tempCheckedRows[i] && !submittalChooserGrid.cells(tempCheckedRows[i], 0).cell._disabled)
						checkedRows.push(tempCheckedRows[i]);
				}

				if (checkedRows.length === 0)
					submittalChooserGridTb.disableItem('add');
				else
					submittalChooserGridTb.enableItem('add');
			});

			submittalChooserGridTb = new dhtmlXToolbarObject("submittalChooserGridToolbar");
			submittalChooserGridTb.setSkin("dhx_web");
			submittalChooserGridTb.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
			submittalChooserGridTb.addInput('searchFor', 0, '', 200);
			submittalChooserGridTb.addSeparator('search_sep', 1);
			submittalChooserGridTb.addButton("search", 2, "Search", "action_search.gif", "");
			submittalChooserGridTb.addSpacer("search");
			submittalChooserGridTb.addSeparator("add", 3);
			submittalChooserGridTb.addButton("add", 4, "Add Selected", "AddContact.png", "AddContactD.png");
			submittalChooserGridTb.disableItem('add');
			submittalChooserGridTb.attachEvent("onClick", function (id) {
				switch (id) {
					case 'search':
						submittalChooserGrid.loadXML(getGridURLSubmittalChooser());
						break;
					case 'add':
						var i = 0;
						for (i = 0; i < submittalChooserGrid.getRowsNum(); i++) {
							if (submittalChooserGrid.cells2(i, 0).isChecked() && !selectedIds.includes(submittalChooserGrid.getRowId(i)))
								selectedIds.push(submittalChooserGrid.getRowId(i));
						}

						if (submittalChooserMode == 'assignedto' && selectedIds.length == 0)
							selectedIds = jQuery(container + ' .submittalAssignedToHidden').val().toString().split(',');

						var selectedIdString = '';
						if (selectedIds.length == 0)
							return;
						else
							selectedIdString = selectedIds.join(',');

						if (submittalChooserMode == 'assignedto') {
							if (jQuery(container + ' .submittalAssignedToHidden').val() != selectedIds[0]
								&& jQuery('#submittal-header .submittal-ball-in-court-select').is(':visible')
								&& jQuery('#submittal-header .submittal-ball-in-court-select').val() == jQuery(container + ' .submittalAssignedToHidden').val())
								jQuery('#submittal-header .submittal-ball-in-court-select').val('');

							jQuery(container + ' .submittalAssignedToHidden').val(selectedIds[0]);
							PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, selectedIds[0], project.ProjectId, 'assignedto|' + container, GetSubmittalContactInfoC, onScriptError);
						}
						else if (submittalChooserMode == 'approverlist') {
							jQuery(container + ' .submittalApproverListHidden').val(selectedIdString);
							PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, selectedIdString, project.ProjectId, 'approverlist|' + container, GetSubmittalContactInfoC, onScriptError);
						}
						else if (submittalChooserMode == 'notifysubmittedlist') {
							jQuery(container + ' .submittalNotifySubmittedListHidden').val(selectedIdString);
							PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, selectedIdString, project.ProjectId, 'notifysubmittedlist|' + container, GetSubmittalContactInfoC, onScriptError);
						}
						else if (submittalChooserMode == 'notifyrejectedlist') {
							jQuery(container + ' .submittalNotifyRejectedListHidden').val(selectedIdString);
							PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, selectedIdString, project.ProjectId, 'notifyrejectedlist|' + container, GetSubmittalContactInfoC, onScriptError);
						}
						else if (submittalChooserMode == 'notifyapprovedlist') {
							jQuery(container + ' .submittalNotifyApprovedListHidden').val(selectedIdString);
							PanteraScript.PanteraScriptService.GetRFIContactInfo(pjqSessionId, selectedIdString, project.ProjectId, 'notifyapprovedlist|' + container, GetSubmittalContactInfoC, onScriptError);
						}

						break;
				}
			});
			//}
		}
	});
}

function getGridURLSubmittalChooser() {
	var response = '/DesktopModules/PJQProjectWallAdmin/GetPCGrid.aspx?dialog=true';


	if (submittalChooserMode == 'assignedto') {
		response += '&dca=1';
	}
	else {
		//response += 'chooser=contacts';

	}

	if (jQuery('#isShowITBSubmittal').prop('checked'))
		response += '&pct=itb'

	response += '&sessionId=' + pjqSessionId;

	if (submittalChooserGridTb != null) {
		var frpSearchFor = submittalChooserGridTb.getValue('searchFor').trim();
		if (frpSearchFor.length > 0)
			response += '&s=' + encodeURI(frpSearchFor);
	}

	return response;
}

function GetSubmittalContactInfoC(response) {
	var addedContacts = jQuery.parseJSON(response);
	populateSubmittalUserLists(addedContacts.ContactList, addedContacts.ContactAddType);

	if (submittalChooserMode != null) {
		submittalChooserMode = null;
		if (jQuery('#submittalChooserDialog').hasClass('ui-dialog-content'))
			jQuery('#submittalChooserDialog').dialog('close');

	}

	/*
	if (addedContacts.ContactAddType == 'distribution') {
		isRFIDistributionListInit = true;
	} else if (addedContacts.ContactAddType == 'assignee') {
		isRFIAssigneeListInit = true;
	}
	hideRFIModal();
	*/
}

function populateSubmittalUserLists(userList, type) {
	var domId = '';
	var parts = type.split('|');
	if (parts[0] == 'assignedto') {
		domId = 'submittalAssignedTo';
	}
	else if (parts[0] == 'approverlist') {
		domId = 'submittalApproverList';
	}
	else if (parts[0] == 'notifysubmittedlist') {
		domId = 'submittalNotifySubmittedList';
	}
	else if (parts[0] == 'notifyrejectedlist') {
		domId = 'submittalNotifyRejectedList';
	}
	else if (parts[0] == 'notifyapprovedlist') {
		domId = 'submittalNotifyApprovedList';
	}
	var element = jQuery(parts[1] + ' .' + domId);
	element.empty();

	if (userList.length == 0) {
		element.html("None");
	}
	else {
		var replaceCommas = new RegExp('"', 'g');

		for (var i = 0; i < userList.length; i++) {
			var displayName = userList[i].Name + ' \n(' + userList[i].CompanyName + ')';
			displayName = displayName.replace(replaceCommas, '');

			var title = userList[i].CompanyName + '\n' + userList[i].Name + '\n' + userList[i].Email + '\n' + FormatPhoneHelper(userList[i].Phone);
			title = title.replace(replaceCommas, '');

			var approvalClass = '';
			if (parts[0] == 'approverlist') {
				displayName = (i + 1).toString() + ') ' + displayName;

				for (var j = 0; j < submittal.ApprovalStatusInfo.length; j++) {
					if (userList[i].Id == submittal.ApprovalStatusInfo[j].ApproverId) {
						if (submittal.ApprovalStatusInfo[j].IsApproved === true)
							approvalClass = ' l-approver-approved';
						else if (submittal.ApprovalStatusInfo[j].IsApproved === false)
							approvalClass = ' l-approver-rejected';
					}
				}
			}

			var enablePeople = (submittal.IsAdmin && submittal.SubmittalStatus < 3);
			if (settings.AllowSubmittalPeopleEditAfterSubmit && submittal.IsAdmin && submittal.SubmittalStatus < 4)
				enablePeople = true;

			if (enablePeople)
				element.append('<div title="' + title + '" class="submittalUserObject' + approvalClass + ' ' + parts[0] + '_' + userList[i].Id + '"><div class="submittalUserObjectName">' + displayName + '</div><div class="submittalUserObjectButtonContainer"><span onclick="deleteSubmittalContact(' + userList[i].Id + ',\'' + parts[0] + '\',\'' + parts[1] + '\')" class="ui-icon ui-icon-closethick"></span></div></div>');
			else
				element.append('<div title="' + title + '" class="submittalUserObject' + approvalClass + ' ' + parts[0] + '_' + userList[i].Id + '"><div class="submittalUserObjectName">' + displayName + '</div></div>');
		}

		if (parts[0] == 'approverlist') {
			if (submittal.IsAdmin && submittal.SubmittalStatus < 3) {
				element.sortable({
					stop: function (event, ui) {
						var itemList = jQuery(parts[1] + ' .submittalApproverList > div');
						var approverList = [];
						for (var i = 0; i < itemList.length; i++) {
							if (jQuery(itemList[i]).hasClass('ui-sortable-placeholder'))
								continue;
							var id = '';
							var classes = jQuery(itemList[i]).attr('class').split(' ');
							for (var j = 0; j < classes.length; j++) {
								var className = classes[j];
								if (className.indexOf('_') != -1) {
									id = className.substring(className.indexOf('_') + 1);
									approverList.push(id);
								}
							}

							var name = jQuery('.submittalUserObjectName', itemList[i]).text();
							name = (i + 1).toString() + ') ' + name.substring(name.indexOf(' ') + 1);
							;
							jQuery('.submittalUserObjectName', itemList[i]).text(name);
						}

						element.parent().find('.submittalApproverListHidden').val(approverList.join(','));
					}
				});
			}
		}

		if (settings.AllowSubmittalPeopleEditAfterSubmit && submittal.IsAdmin && submittal.SubmittalStatus > 1 && submittal.SubmittalStatus < 4) {
			SubmittalRebuildBallInCourtSelect();
		}

	}
}

function deleteSubmittalContact(id, type, container) {

	var tempArr = [];
	var domId = '';
	if (type == 'assignedto') {
		domId = 'submittalAssignedTo'
		jQuery(container + ' .' + domId + 'Hidden').val('');
		jQuery(container + ' .' + domId).text('None');
	}
	else if (type == 'approverlist') {
		domId = 'submittalApproverList';
		tempArr = jQuery(container + ' .' + domId + 'Hidden').val().split(',');
		RemoveIfPresent(tempArr, id.toString());
		jQuery(container + ' .' + domId + 'Hidden').val(tempArr.join(','));
		if (tempArr.length == 0)
			jQuery(container + ' .' + domId).text('None');
	}
	else if (type == 'notifysubmittedlist') {
		domId = 'submittalNotifySubmittedList';
		tempArr = jQuery(container + ' .' + domId + 'Hidden').val().split(',');
		RemoveIfPresent(tempArr, id.toString());
		jQuery(container + ' .' + domId + 'Hidden').val(tempArr.join(','));
		if (tempArr.length == 0)
			jQuery(container + ' .' + domId).text('None');
	}
	else if (type == 'notifyrejectedlist') {
		domId = 'submittalNotifyRejectedList';
		tempArr = jQuery(container + ' .' + domId + 'Hidden').val().split(',');
		RemoveIfPresent(tempArr, id.toString());
		jQuery(container + ' .' + domId + 'Hidden').val(tempArr.join(','));
		if (tempArr.length == 0)
			jQuery(container + ' .' + domId).text('None');
	}
	else if (type == 'notifyapprovedlist') {
		domId = 'submittalNotifyApprovedList';
		tempArr = jQuery(container + ' .' + domId + 'Hidden').val().split(',');
		RemoveIfPresent(tempArr, id.toString());
		jQuery(container + ' .' + domId + 'Hidden').val(tempArr.join(','));
		if (tempArr.length == 0)
			jQuery(container + ' .' + domId).text('None');
	}

	if (jQuery('#submittal-header .submittal-ball-in-court-select').is(':visible') && jQuery('#submittal-header .submittal-ball-in-court-select').val() == id.toString()) {
		SubmittalRebuildBallInCourtSelect();
		jQuery('#submittal-header .submittal-ball-in-court-select').val('');
	}

	jQuery(container + ' .' + type + '_' + id).remove();

	if (settings.AllowSubmittalPeopleEditAfterSubmit && submittal.IsAdmin && submittal.SubmittalStatus > 1 && submittal.SubmittalStatus < 4) {
		SubmittalRebuildBallInCourtSelect();
	}

}

/* Groups Chooser */
function getTreeURLSubmittalGroups(isFilterGroups) {
	return "/DesktopModules/PJQProjectWallAdmin/GetGroupTree.aspx?sessionId=" + pjqSessionId + (isFilterGroups ? '&pc=true' : '&rfi=true');
}

function refreshTreeSubmittalGroups() {
	submittalGroupsTree.deleteChildItems(0);
	submittalGroupsTree.loadJSON(getTreeURLSubmittalGroups());
}

var contactGroupsFilterSubmittal = [];

function initSubmittalGroupsDialog(existingGroups, mode, container) {
	initSubmittalGroupsTree(false, mode, existingGroups, container);

	jQuery('#submittalGroupsDialog').dialog({
		title: 'Add Submittal Trades',
		modal: true,
		resizable: false,
		dialogClass: 'submittalGroupsDialog',
		width: 550,
		height: 350,
		position: 'top',
		open: function (e, ui) {

		}
	})
}

var submittalGroupsTree = null, submittalGroupsTreeTb = null;

function initSubmittalGroupsTree(isOnLoad, mode, existingGroups, container) {
	if (submittalGroupsTree != null) {
		submittalGroupsTree.destructor();
		submittalGroupsTree = null;
	}
	submittalGroupsTree = new dhtmlXTreeObject("submittalGroupsTree", "100%", "100%", 0);
	submittalGroupsTree.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxtree/imgs/');
	submittalGroupsTree.enableCheckBoxes(1);
	submittalGroupsTree.enableMultiLineItems("300px");
	submittalGroupsTree.enableTreeLines(false);
	submittalGroupsTree.enableTreeImages(false);
	submittalGroupsTree.setDataMode('json');
	var isFilterGroups = false;
	if (mode == "contactfilter")
		isFilterGroups = true;
	submittalGroupsTree.loadJSON(getTreeURLSubmittalGroups(isFilterGroups));

	submittalGroupsTree.attachEvent('onXLE', function () {
		if (isOnLoad)
			populateSubmittalGroupList(container);

		if (existingGroups != null) {
			for (var i = 0; i < existingGroups.length; i++) {
				if (submittalGroupsTree.getIndexById(existingGroups[i]) != null) {
					submittalGroupsTree.setCheck(existingGroups[i], 1);
					submittalGroupsTree.disableCheckbox(existingGroups[i], 1);
				}
			}
		}
	});

	submittalGroupsTree.attachEvent('onCheck', function () {
		var tempCheckedRows = submittalGroupsTree.getAllChecked().split(',');
		var checkedRows = [];
		for (var i = 0; i < tempCheckedRows.length; i++) {
			if (existingGroups.indexOf(tempCheckedRows[i]) == -1)
				checkedRows.push(tempCheckedRows[i]);
		}
		if (checkedRows.length === 0)
			submittalGroupsTreeTb.disableItem('add');
		else
			submittalGroupsTreeTb.enableItem('add');
	});

	if (submittalGroupsTreeTb != null) {
		submittalGroupsTreeTb.unload();
		submittalGroupsTreeTb = null;
	}

	submittalGroupsTreeTb = new dhtmlXToolbarObject("submittalGroupsTreeToolbar");
	submittalGroupsTreeTb.setSkin("dhx_web");
	submittalGroupsTreeTb.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	var addLabel = "Add Selected";
	if (mode == "contactfilter")
		addLabel = "Filter";
	submittalGroupsTreeTb.addButton("add", 4, addLabel, "New.gif", "New_dis.gif");
	submittalGroupsTreeTb.disableItem('add');
	submittalGroupsTreeTb.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				var selectedGroupsArr = [];
				if (existingGroups.length > 0 && mode != 'contactfilter')
					selectedGroupsArr = existingGroups.split(',');
				var newGroupsArr = submittalGroupsTree.getAllChecked().split(',');
				for (var i = 0; i < newGroupsArr.length; i++) {
					if (selectedGroupsArr.indexOf(newGroupsArr[i]) == -1 && newGroupsArr[i].length > 0)
						selectedGroupsArr.push(newGroupsArr[i]);
				}
				if (mode == 'submittalinfo') {
					jQuery(container + ' .submittalGroupIdList').val(selectedGroupsArr.join(','));
					populateSubmittalGroupList(container);
				}
				else if (mode == "contactfilter") {
					contactGroupsFilterSubmittal = selectedGroupsArr;
					submittalProjectContactsGridTb.setItemText("groups", contactGroupsFilterSubmittal.length.toString() + " " + settings.GroupLabel);
					refreshGridSubmittalProjectContacts();
				}

				jQuery('#submittalGroupsDialog').dialog('close');
				break;
		}
	});
}

function populateSubmittalGroupList(container) {
	if (submittal != null) {
		jQuery(container + ' .submittalGroups').empty();
		var selectedGroupsArr = [];
		var groupIdList = jQuery(container + ' .submittalGroupIdList').val();

		if (groupIdList.length > 0)
			selectedGroupsArr = groupIdList.split(',');
		if (selectedGroupsArr.length > 0) {
			for (var i = 0; i < selectedGroupsArr.length; i++) {
				if (submittalGroupsTree.getIndexById(selectedGroupsArr[i]) != null && selectedGroupsArr[i].length > 0) {
					var groupName = submittalGroupsTree.getItemText(selectedGroupsArr[i]);

					if (submittal.IsAdmin && submittal.SubmittalStatus < 3)
						jQuery(container + ' .submittalGroups').append('<div title="' + groupName + '" class="submittalGroupObject submittalGroup_' + selectedGroupsArr[i] + '"><div class="submittalGroupObjectName">' + groupName + '</div><div class="submittalGroupObjectButtonContainer"><span onclick="deleteSubmittalGroup(' + selectedGroupsArr[i] + ',\'' + container + '\')" class="ui-icon ui-icon-closethick"></span></div></div>');
					else
						jQuery(container + ' .submittalGroups').append('<div title="' + groupName + '" class="submittalGroupObject submittalGroup_' + selectedGroupsArr[i] + '"><div class="submittalGroupObjectName">' + groupName + '</div><div class="submittalGroupObjectButtonContainer"></div></div>');
				}
			}
		}
		else {
			jQuery(container + ' .submittalGroups').html("No " + settings.GroupLabel);
		}

		if (submittal.SubmittalStatus > 1) {
			jQuery(container + ' .submittalGroupObjectButtonContainer').hide();
		}
	}
}

function deleteSubmittalGroup(id, container) {
	var existingGroups = [];
	var newGroups = [];
	var groupIdList = jQuery(container + ' .submittalGroupIdList').val();
	if (groupIdList.length > 0)
		existingGroups = groupIdList.split(',');
	for (var i = 0; i < existingGroups.length; i++) {
		if (parseInt(existingGroups[i]) != parseInt(id))
			newGroups.push(existingGroups[i]);
	}

	jQuery(container + ' .submittalGroupIdList').val(newGroups.join(','));
	groupIdList = jQuery(container + ' .submittalGroupIdList').val();

	jQuery(container + ' .submittalGroup_' + id).remove();
	if (groupIdList.length == 0)
		jQuery(container + ' .submittalGroups').html("No " + settings.GroupLabel);
}

function SubmittalHistoryExport() {
	var header = "<html><head> <BASE HREF='http://www.lakeviewestimating.com/'>";

	var classlist = "<style>#submittalHistoryContainer{width: 100%;}.submittalHistoryObject{margin:5px auto;border-bottom:1px dotted black;}.submittalHistoryObjectDetail{width:40%;float:left;background: #DADADA;}.submittalHistoryObjectName{font-weight:bold;padding:5px 0 3px 5px;}.submittalHistoryObjectDate{padding:5px 0 3px 5px;}.submittalHistoryObjectActionContainer{width:60%;float:right;}.submittalHistoryObjectAction{margin:10px;}.submittalHistoryDeletedResponse{padding: 5px;margin: 5px 0;background: #eee;border: 1px solid #909090;border-radius: 4px;}</style>";

	var endheader = "</head><body><div style='width:95%; margin: auto;'><div style='font-size: 18pt; font-weight bold'>Submittal # " + jQuery('#submittal-header .submittal-number').val() + " History</div>"

	var data = jQuery('#submittalHistoryContainer').html();

	var footer = "</div></body></html>";

	var xmlFile = "/DesktopModules/PJQProjectWallAdmin/ExportSubmittalEditHistory.aspx";
	ShowBusy('Exporting...');
	jQuery.ajax({
		url: xmlFile,
		type: 'POST',
		data: "?store=1&data=" + encodeURIComponent(header + classlist + endheader + data + footer),
		success: function (result) {
			HideBusy();
			showInfoDialogSubmittal('Export Complete', '<a href="' + result + '" target="_blank">Click here to download your export.</a>', 'ui-icon-info');
		},
		error: function (xhr, status, error) {
			HideBusy();
			showInfoDialogSubmittal('Export Error', "An error occurred during export: " + error, 'ui-icon-alert');
		}
	});

}


function SubmittalHistoryButton(context) {
	jQuery('#submittalHistoryContainer').hide();
	jQuery('#submittalHistoryContainer').html('');
	jQuery('#submittalHistoryLoading').show();
	var xmlFile = '';
	var dlgTitle = '';

	if (context == 'edit') {
		xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetSubmittalGrid.aspx?sessionid=' + pjqSessionId + '&list=history&id=' + submittal.SubmittalId.toString() + '&x=' + (new Date).getTime();
		dlgTitle = 'Edit History';

		jQuery.ajax({
			type: "POST",
			url: xmlFile,
			dataType: "text",
			success: function (result) {
				var dlgWidth = jQuery(window).width() - (jQuery(window).width() * 0.25);
				var dlgHeight = jQuery(window).height() - (jQuery(window).height() * 0.50);
				jQuery('#submittalHistoryContainer').show();
				jQuery('#submittalHistoryLoading').hide();

				var history = jQuery.parseJSON(result);
				for (var i = 0; i < history.length; i++) {
					submittalHistoryParse(history[i]);
				}

				jQuery('#submittal-history-dialog').dialog({
					title: dlgTitle,
					modal: true,
					resizable: false,
					width: dlgWidth,
					height: dlgHeight,
					position: 'top',
					buttons: {
						Export: function () {
							SubmittalHistoryExport();
						}
					}
				});

			},
			error: function (xhr, status, error) {
				showInfoDialogSubmittal('Load Error', "An error occurred while loading data: " + error, 'ui-icon-alert');
			}
		});
	}
	else if (context == 'notification') {
		new PJQ.models.submittals.Submittals({
			submittalId: submittal.SubmittalId
		}).fetchNotifications(function (notifications) {
			new PJQ.views.notifications.NotificationHistory({
				collection: notifications
			});
		});
	}
}

function submittalNotificationHistoryParse(history) {
	//[{ "broadcastStatus": "EMAIL SENT", "broadcastErrorMessage": "", "createdBy": "Rick Rye (Sunland Fire Protection)", "createdOn": "5/18/2017 2:34:13 AM", "notificationType": "Ball In Court" }]
	//setClipboardText

	var html = '<div class="submittalHistoryObject"><div class="submittalHistoryObjectDetail" style="height:74.2px;"><div class="submittalHistoryObjectName">' + history.createdBy + '</div><div class="submittalHistoryObjectDate">' + history.createdOn + '</div></div><div class="submittalHistoryObjectActionContainer"><div class="submittalHistoryObjectAction"><b>' + history.notificationType + '</b><br />' + history.broadcastStatus + '<br />' + history.linkURL + '</div></div><div style="clear:both;"></div></div>';
	jQuery('#submittalHistoryContainer').append(html);
}


function submittalHistoryParse(history) {
	var fromValue = '';
	if (history.oldValue)
		fromValue = ' from "' + history.oldValue + '" ';
	var html = '<div class="submittalHistoryObject"><div class="submittalHistoryObjectDetail" style="height: 58.2px;"><div class="submittalHistoryObjectName">' + history.createdBy + '</div><div class="submittalHistoryObjectDate">' + history.createdOn + '</div></div><div class="submittalHistoryObjectActionContainer"><div class="submittalHistoryObjectAction"><b>' + history.itemName + '</b> changed ' + fromValue + 'to "' + history.newValue + '".</div></div><div style="clear:both;"></div></div>';
	jQuery('#submittalHistoryContainer').append(html);
}


var submittalLeftCommandsDisabled = false, resizeTimerSubmittal = null;

function SubmittalSwitchLeftCommands() {
	jQuery('#projectCommands').hide();
	jQuery('#submittalCommands').show();
}


function SubmittalEnableLeftCommands() {
	jQuery('#projectCommands').show();
	jQuery('#submittalCommands').hide();
}

function submittalAddComment() {
	var newComment = jQuery('#submittal-comment').val();
	if (newComment) {
		submittalNewComments.push(newComment);
		var createdOnDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);

		var commentTemp = {comment: newComment, createdBy: submittal.MyCreatedByDisplay, createdOn: createdOnDisplay};
		submittalCommentParse(commentTemp);
		jQuery('#submittal-comment').val('');
	}
}

function submittalCommentParse(comment) {
	var html = '<div class="pantera-comment"><div class="pantera-comment-header">' + comment.createdBy + ' @ ' + comment.createdOn + '</div><div class="pantera-comment-body">' + comment.comment + '</div></div>';

	jQuery('#submittal-comment-grid').append(html);
}

function SubmittalRefreshComments() {
	var xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetSubmittalGrid.aspx?sessionid=' + pjqSessionId + '&list=comments&id=' + submittal.SubmittalId.toString() + '&x=' + (new Date).getTime();
	jQuery.ajax({
		type: "POST",
		url: xmlFile,
		dataType: "text",
		success: function (result) {
			jQuery('#submittal-comment-grid').html('');
			var comments = jQuery.parseJSON(result);
			for (var i = 0; i < comments.length; i++) {
				submittalCommentParse(comments[i]);
			}
		},
		error: function (xhr, status, error) {
			showInfoDialogSubmittal('Save Error', "An error occurred while loading data: " + error, 'ui-icon-alert');
		}
	});
}

function setClipboardText(text) {
	var id = "mycustom-clipboard-textarea-hidden-id";
	var existsTextarea = document.getElementById(id);

	if (!existsTextarea) {
		var textarea = document.createElement("textarea");
		textarea.id = id;
		// Place in top-left corner of screen regardless of scroll position.
		textarea.style.position = 'fixed';
		textarea.style.top = 0;
		textarea.style.left = 0;

		// Ensure it has a small width and height. Setting to 1px / 1em
		// doesn't work as this gives a negative w/h on some browsers.
		textarea.style.width = '1px';
		textarea.style.height = '1px';

		// We don't need padding, reducing the size if it does flash render.
		textarea.style.padding = 0;

		// Clean up any borders.
		textarea.style.border = 'none';
		textarea.style.outline = 'none';
		textarea.style.boxShadow = 'none';

		// Avoid flash of white box if rendered for any reason.
		textarea.style.background = 'transparent';
		document.querySelector("body").appendChild(textarea);
		existsTextarea = document.getElementById(id);
	}

	existsTextarea.value = text;
	existsTextarea.select();

	try {
		document.execCommand('copy');
	} catch (err) {

	}
}

function SubmittalExport(submittalId) {
	if (!submittalId)
		submittalId = submittal.SubmittalId;
	var xmlFile = "/DesktopModules/PJQProjectWallAdmin/SubmittalExport.aspx";
	ShowBusy('Exporting...');
	jQuery.ajax({
		url: xmlFile,
		type: 'POST',
		data: "subid=" + submittalId + "&s=" + pjqSessionId + '&x=' + (new Date).getTime(),
		success: function (result) {
			HideBusy();
			showInfoDialogSubmittal('Export Complete', '<a href="' + result + '" target="_blank">Click here to download your export.</a>', 'ui-icon-info');
		},
		error: function (xhr, status, error) {
			HideBusy();
			showInfoDialogSubmittal('Export Error', "An error occurred during export: " + error, 'ui-icon-alert');
		}
	});
}

function SubmittalExportAll() {
	PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'projects',
			value: PJQ.app.session.project.id
		},
		{
			endpoint: 'submittals',
		},
		{
			endpoint: 'export'
		}
	]));
}

function initSubmittalConfirmDialog(title, text, type, optionalArg1) {
	jQuery('#submittalConfirmDialog').html(text);
	if (type == 'formaction1' || type == 'formaction2') {
		jQuery('#submittal-formaction-duedate').datepicker({
			showOn: "button",
			numberOfMonths: 3,
			showButtonPanel: true,
			buttonImage: "/i/calendar.png",
			buttonImageOnly: true,
			onSelect: function (name, sender) {
				//validator.element('#' + jQuery(sender).attr('id'));
			}
		});
		var newDueDate = new Date(jQuery('#submittal-header .submittal-due-date').val());

		var isFinalApprover = false;
		var approvers = submittal.ApproverList.split(',');
		if (approvers && parseInt(approvers[approvers.length - 1]) == submittal.CreatedBy)
			isFinalApprover = true;

		if (submittal.ApprovalMode == 1) {
			if (!isFinalApprover || type == 'formaction2')
				newDueDate.setDate(newDueDate.getDate() + submittal.SubmittalDueDays);
			else
				jQuery('#submittal-formaction-duedate').parent().parent().hide();

		}
		else if (submittal.ApprovalMode == 2) {
			if ((isFinalApprover || (submittal.IsAdmin && !submittal.IsApprover)) && type == 'formaction2')
				newDueDate.setDate(newDueDate.getDate() + submittal.SubmittalDueDays);
			else
				jQuery('#submittal-formaction-duedate').parent().parent().hide();

		}

		/*
		if (submittal.ApprovalMode == 1 || (isFinalApprover && type == 'formaction2')) {
			newDueDate.setDate(newDueDate.getDate() + submittal.SubmittalDueDays);

			if ((!(submittal.IsApprover && submittal.IsBallInCourt) && !submittal.IsAdmin) || (isFinalApprover && type == 'formaction1'))
				jQuery('#submittal-formaction-duedate').parent().parent().hide();
		}
		*/

		// no matter what, non admins can't see the due date field.
		if (!submittal.IsAdmin)
			jQuery('#submittal-formaction-duedate').parent().parent().hide();

		jQuery('#submittal-formaction-duedate').val(PJQ.helpers.dateHelpers.getDateString(newDueDate, PJQ.helpers.dateHelpers.dateFormats.DATE));

		jQuery('#submittal-formaction-comment').val('');
	}

	jQuery('#submittalConfirmDialog').dialog({
		title: title,
		modal: true,
		resizable: false,
		dialogClass: 'submittalConfirmDialog',
		width: "auto",
		height: "auto",
		buttons: [{
			text: "Yes",
			click: function () {
				switch (type) {
					case 'deleteSubmittalFile':
						SubmittalFileDelete2(optionalArg1);
						break;
					case 'formaction1':
						SubmittalFormAction1(jQuery('#submittal-formaction-comment').val(), jQuery('#submittal-formaction-duedate').val());
						break;
					case 'formaction2':
						SubmittalFormAction2(jQuery('#submittal-formaction-comment').val(), jQuery('#submittal-formaction-duedate').val());
						break;
					case 'delete-submittal-file':
						PanteraScript.PanteraScriptService.DeleteSubmittalDocument(pjqSessionId, submittalDocumentId, SubmittalFilesUploaded, onScriptError);
						break;
					case 'deleteInappopriateApprovers':
						for (var i = 0; i < optionalArg1.length; i++) {
							deleteSubmittalContact(optionalArg1[i], 'approverlist', '#submittal-header');
						}
						SubmittalSave(false);

						break;
				}
				jQuery('#submittalConfirmDialog').dialog('close');
			}
		}, {
			text: "No",
			click: function () {
				switch (type) {
					case 'deleteFieldReportFile':
						//Do nothing probably
						break;
				}
				jQuery('#submittalConfirmDialog').dialog('close');
			}
		}]
	});
}

var submittalFilesGuid = null;

function CreateSubmittalFilesForm(response) {
	submittalFilesGuid = response;

	jQuery('#submittal-files2 table tbody tr').remove();
	jQuery('#submittal-files2 div.dropnotice').show();

	jQuery('#submittal-files-dialog').dialog({
		title: 'Upload Files',
		modal: true,
		resizable: false,
		dialogClass: 'submittalFilesDialog',
		width: 550,
		height: 290,
		position: 'top',
		open: function (e, ui) {
			var maxFileCount = undefined;
			var fileTypeFilter = /.+$/i;
			var actionURL =
				PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + submittalFilesGuid + '&sid=' + pjqSessionId;
			jQuery('#submittal-fileupload2').fileupload();
			jQuery('#submittal-fileupload2').fileupload('option', {
				autoUpload: true,
				maxNumberOfFiles: maxFileCount,
				acceptFileTypes: fileTypeFilter,
				url: actionURL,
				dropZone: jQuery('#submittal-fileupload2')
			});
			jQuery('.ui-dialog-buttonset button').button('disable');

			jQuery('#submittal-fileupload2').bind('fileuploadstop', function (e, data) {
				jQuery('.ui-dialog-buttonset button').button('enable');
			});
			jQuery('#submittal-fileupload2').bind('fileuploadstart', function (e, data) {
				jQuery('.ui-dialog-buttonset button').button('disable');
			});

		},
		buttons: {
			"Continue": function () {
				PanteraScript.PanteraScriptService.AddSubmittalDocuments(pjqSessionId, submittal.SubmittalId, parentSubmittalDocumentId, submittalFilesGuid, SubmittalFilesUploaded, onScriptError);
			}
		}
	})

}

function SubmittalFilesUploaded(response) {
	if (!SubmittalSubWallCheck())
		submittalFilesToolbar.disableItem('delete');
	submittalFilesToolbar.disableItem('download');
	submittalFilesToolbar.disableItem('addv');

	submittalFilesGrid.clearAll();
	submittalFilesGrid.loadXML("/DesktopModules/PJQProjectWallAdmin/GetSubmittalGrid.aspx?sessionid=" + pjqSessionId + '&id=' + submittal.SubmittalId.toString() + '&list=files&x=' + (new Date).getTime(), function () {
		if (submittalFilesGrid.getRowsNum() > 0) {
			submittalFilesToolbar.enableItem('downloadAll');
		}
	});

	try {
		jQuery('#submittal-files-dialog').dialog('destroy');
	} catch (err) {
	}
}

function DownloadSubmittalFile(entryId) {
	// if (SubmittalSubWallCheck())
	// 	DownloadFile(entryId);
	// else
	// 	pjqDL(entryId);
	PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'files',
			value: entryId
		},
		{
			endpoint: 'downloadentryid'
		}
	]), {
		isEndpoint: true,
		isApi2: true
	});
}

var submittalBatchDivId = 0;

function CreateAddBatchForm() {
	PanteraScript.PanteraScriptService.GetSubmittalInfo(pjqSessionId, 0, CreateAddBatchFormC, onScriptError);
}

function CreateAddBatchFormC(response) {
	submittal = jQuery.parseJSON(response);
	submittalFormReadOnly = false;
	submittalNewComments = [];

	submittalFormWidth = 99.8;

	jQuery('#submittal-save').button('option', 'label', 'Save Batch');

	if (SubmittalSubWallCheck()) {
		jQuery('#submittal-edit-form').css('display', 'inline-block');
		jQuery('#tabsLeft').before(jQuery('#submittal-edit-form'));
		jQuery('#leftbar').css('vertical-align', 'top');
		jQuery('#submittal-edit-form').css('border', 'solid 1px black');
		jQuery('#submittal-edit-form').css('padding', '6px');
		jQuery('#submittal-edit-form').css('margin-left', '12px');
		jQuery('#submittal-edit-form').css('width', '70%');
		jQuery('#submittal-edit-form').css('min-width', '920px');
		jQuery('#tabsLeft, #tabsRight').hide();
	}
	else {
		jQuery('#tabsMain').tabs('option', 'disabled', [0, 1, 2, 3, 4, 6, 7, 8]);
		toggleTabs('li-project-submittals', false);
	}
	SubmittalSwitchLeftCommands();

	// clear prior contents
	jQuery('#submittal-batch-add-form').empty();

	// add a blank one
	BatchAddBlankC();

	// show the form
	jQuery('#submittal-list-container, #submittal-action1, #submittal-action2').hide();
	jQuery('#submittal-batch-add-form').show();
}

function BatchAddBlankC() {
	submittalBatchDivId++;
	var containerId = "submittal-batch-" + submittalBatchDivId.toString();
	var container = '#' + containerId;

	var addContainer = "<div class='submittal-batch-add'><button type='button' class='submittal-batch-add-blank' onclick='BatchAddBlankC()'>Add Blank Submittal</button>&nbsp;&nbsp;&nbsp;<button type='button' class='submittal-batch-copy' onclick='CopySubmittalBatch(this)'>Copy Submittal</button>&nbsp;<input type='text' class='submittal-batch-copy-number' value='1' />&nbsp;Time(s)<button type='button' class='submittal-batch-delete' onclick='DeleteSubmittalBatch(this);'>Delete</button></div>";
	var newContainer = "<div id='" + containerId + "' class='submittal-batch-row'>" + addContainer + "</div>";
	jQuery('#submittal-batch-add-form').append(newContainer);
	jQuery(container + ' button.submittal-batch-add-blank,' + container + ' button.submittal-batch-copy,' + container + ' button.submittal-batch-delete').button();

	jQuery(container + ' input.submittal-batch-copy-number').spinner({
		min: 1,
		max: 50,
		step: 1
	});

	jQuery(container + ' div.submittal-batch-add').before(submittalTemplates.submittalHeader.jsRenderTemplate.render());
	jQuery(container + ' table.submittal-fields-admin').before(jQuery(container + ' table.submittal-commands'));
	jQuery(container + ' table.submittal-commands button').hide();
	jQuery(container + ' td.submittal-status-label').hide();
	jQuery(container + ' .submittal-received-date').closest('tr').hide();
	jQuery(container + ' .submittal-number').removeClass('required');

	if (submittal.IsGroupsRequired)
		jQuery(container + ' .submittalGroupsRequired').text('*');

	jQuery(container + ' .submittalGroups').text('');


	jQuery(container + ' input.submittal-number').val('');

	jQuery(container + ' .submittalGroupIdList').val(submittal.GroupIdList);
	jQuery(container + ' .submittalGroups').html("No " + settings.GroupLabel);
	jQuery(container + ' .addSubmittalGroupsButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		var groupIdList = jQuery(container + ' .submittalGroupIdList').val();
		initSubmittalGroupsDialog(groupIdList, 'submittalinfo', container);
	});

	jQuery(container + ' .submittalAssignedToHidden').val(submittal.AssignedTo);
	jQuery(container + ' .submittalAssignedTo').html('None');
	jQuery(container + ' .addSubmittalAssignedToButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('assignedto', container);
	});

	jQuery(container + ' .submittalApproverListHidden').val(submittal.ApproverList);
	jQuery(container + ' .submittalApproverList').html('None');
	jQuery(container + ' .addSubmittalApproverListButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('approverlist', container);
	});

	jQuery(container + ' .submittalNotifySubmittedListHidden').val(submittal.NotifySubmittedList);
	jQuery(container + ' .submittalNotifySubmittedList').html('None');
	jQuery(container + ' .addSubmittalNotifySubmittedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifysubmittedlist', container);
	});

	jQuery(container + ' .submittalNotifyRejectedListHidden').val(submittal.NotifyRejectedList);
	jQuery(container + ' .submittalNotifyRejectedList').html('None');
	jQuery(container + ' .addSubmittalNotifyRejectedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifyrejectedlist', container);
	});

	jQuery(container + ' .submittalNotifyApprovedListHidden').val(submittal.NotifyApprovedList);
	jQuery(container + ' .submittalNotifyApprovedList').html('None');
	jQuery(container + ' .addSubmittalNotifyApprovedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifyapprovedlist', container);
	});

	jQuery(container + ' .submittal-item-types').empty();
	for (var i = 0; i < submittal.ItemTypes.length; i++) {
		var checked = submittal.ItemTypes[i].IsSelected ? "checked='checked'" : "";
		var html = "<input type='checkbox' name='itemtype' class='pjq-validate-ignore' submittalitemtype='" + submittal.ItemTypes[i].SubmittalItemTypeId + "' " + checked + " /><label>" + submittal.ItemTypes[i].ItemType + "</label><br />";
		jQuery(container + ' .submittal-item-types').append(html);
	}

	jQuery(container + ' .submittal-item-types input').rules('remove');

	jQuery(container + ' .submittal-created-by').html(submittal.CreatedByDisplay + ' at ' + submittal.CreatedOn);

	jQuery(container + ' .submittal-due-date,' + container + ' .submittal-received-date').mask('99/99/9999', {
		placeholder: " "
	});

	jQuery(container + ' .submittal-due-date,' + container + ' .submittal-received-date').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: function (name, sender) {
			window.validator.element('#' + jQuery(sender).attr('id'));
		}
	});
	jQuery(container + ' .submittal-due-date').val(submittal.DueDate);

	var template = '';
	template += "<tr class='pjq-custom-field'>";
	template += "       <td class='pjq-field-label' style='width: 15%;'>{{>FieldName}}</td>";
	template += "      {{if IsRequired}}<td class='pjq-label-required' style='width: 8px;'>*</td>{{else}}<td style='width: 8px;'>&nbsp;</td>{{/if}}";
	template += "      <td class='pjq-field-value' submittal-field-type='{{attr:FieldType}}' colspan='2'>";

	template += "{{if FieldType == 'TEXT'}}";
	template += "       <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-default-field-width{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' maxlength='255' />";
	template += "{{else FieldType == 'TEXTAREA'}}";
	template += "       <textarea submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-textarea-field-width {{if IsRequired}} required{{/if}}' >{{attr:FieldValue}}</textarea>";
	template += "{{else FieldType == 'INT'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-numeric-field-width integer{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' maxlength='10'{{if NumericMinValue > 0}} min='{{attr:NumericMinValue}}'{{/if}}{{if NumericMaxValue > 0}}  max='{{attr:NumericMaxValue}}'{{/if}} />";
	template += "{{else FieldType == 'DATE'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-date-field-width{{if IsRequired}} date required{{else}} dateOPT{{/if}}' value='{{>~parseDateDT(FieldValue)}}' maxlength='10' />";
	template += "{{else FieldType == 'DATETIME'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-date-field-width{{if IsRequired}} date required{{else}}{{/if}} pjq-datetime' value='{{>~parseDateDT(FieldValue)}}' maxlength='10' />&nbsp;&nbsp;<input submittalfieldid='submittal-custom2-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-time-field-width {{if IsRequired}} time12h required{{else}} time12hOPT{{/if}}' value='{{>~parseTimeDT(FieldValue)}}' maxlength='8' /><img id='submittal-custom2-tp-{{attr:FieldReportCustomFieldId}}' class='ui-timepicker-trigger' src='/i/icon_scheduler_16px.gif' alt='...' title='...'>";
	template += "{{else FieldType == 'MONEY'}}";
	template += "         <input submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' type='text' class='pjq-money-field-width{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' onchange='FormatCurrencyHelper(jQuery(this));' />";
	template += "{{else FieldType == 'BOOL'}}";
	template += "         <select submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-bool-field-width{{if IsRequired}} selectREQ{{/if}}' >";
	template += "          <option value=''>Select Answer...</option>";
	template += "          <option value='true'{{if FieldValue == 'true' || FieldValue == 'Yes'}} selected='selected'{{/if}}>Yes</option>";
	template += "          <option value='false'{{if FieldValue == 'false' || FieldValue == 'No'}} selected='selected'{{/if}}>No</option>";
	template += "         </select>";
	template += "{{else FieldType == 'CHOICE'}}";
	template += " {{if IsChoiceListMultipleChoice}}";
	template += "          <div submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-choice-field-width pjq-multiple-choice-list {{if IsRequired}} pjq-required{{/if}}'  data-choice-list='{{attr:FieldValue}}'>";
	template += " {{for ChoiceList ~FieldReportCustomFieldId=FieldReportCustomFieldId}}";
	template += "          <input type='checkbox' submittalfieldid='submittal-custom-{{>~FieldReportCustomFieldId}}_{{attr:ChoiceId}}' value='{{attr:ChoiceId}}' choice-name='{{attr:ChoiceName}}' />";
	template += "           <label for='submittal-custom-{{attr:FieldReportCustomFieldId}}_{{attr:ChoiceId}}'>{{>ChoiceName}}</label><br />";
	template += " {{/for}}";
	template += "         </div>";
	template += " {{else}}";
	template += "          <select submittalfieldid='submittal-custom-{{attr:FieldReportCustomFieldId}}' class='pjq-choice-field-width{{if IsRequired}} selectREQ{{/if}}' data-choice-list='{{attr:FieldValue}}' >";
	template += "          <option value=''>Select...</option>";
	template += " {{for ChoiceList}}";
	template += "           <option value='{{attr:ChoiceId}}' text='{{attr:ChoiceName}}' {{if FieldValue && FieldValue.toString().indexOf(ChoiceName)>-1}}selected='selected'{{/if}}>{{>ChoiceName}}</option>";
	template += " {{/for}}";
	template += "          </select>";
	template += " {{/if}}";
	template += "{{/if}}";

	template += "</td></tr>";
	var cfTemplate = $.templates(template);

	var i = 0;
	var vendorFieldCount = 0;
	for (i = 0; i < submittal.CustomFields.length; i++) {

		if (!submittal.CustomFields[i].IsEditableNonAdmin)
			jQuery(container + ' .submittal-fields-admin').append(cfTemplate.render(submittal.CustomFields[i]));
	}

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-date-field-width").each(function () {
		if (!jQuery(this).hasClass('hasDatepicker')) {
			jQuery(this).mask('99/99/9999', {
				placeholder: " "
			});
			jQuery(this).datepicker({
				showOn: "button",
				numberOfMonths: 3,
				showButtonPanel: true,
				buttonImage: "/i/calendar.png",
				buttonImageOnly: true,
				onSelect: function (name, sender) {
					window.validator.element('#' + jQuery(sender).attr('id'));
				}
			});
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-time-field-width").each(function () {
		if (!jQuery(this).hasClass('hasTimepicker')) {
			jQuery(this).timepicker({
				showOn: 'button',
				showPeriod: true,
				button: jQuery(this).siblings('.ui-timepicker-trigger'),
				onSelect: function (name, sender) {
					window.validator.element('#' + jQuery(sender).attr('id'));
				}
			});
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-numeric-field-width").each(function () {
		var minVal = 0;
		if (jQuery(this).attr('min'))
			minVal = parseInt(jQuery(this).attr('min'));
		var maxVal = 2147483647;
		if (jQuery(this).attr('max'))
			maxVal = parseInt(jQuery(this).attr('max'));
		jQuery(this).spinner({
			min: minVal,
			max: maxVal,
			step: 1,
			spin: function (event, ui) {
				window.validator.element('#' + jQuery(this).attr('id'));
				//EnableSave();
			}
		});
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field select.pjq-choice-field-width").each(function () {
		var x = jQuery(this).attr('data-choice-list').split('|||');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			//jQuery(this).find("option[value='"+x[i].trim()+"'], option[text='"+x[i].trim()+"']").attr('selected','selected');
			jQuery(this).find("option[value='" + x[i].trim() + "'], option[text='" + x[i].trim() + "']").prop('selected', true);
			//jQuery(this).find("option[text='"+x[i].trim()+"']").attr('selected','selected');
			jQuery(this).find("option[text='" + x[i].trim() + "']").prop('selected', true);
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field div.pjq-multiple-choice-list").each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("input[value='" + x[i].trim() + "']").prop('checked', true);
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-money-field-width").each(function () {
		FormatCurrencyHelper(jQuery(this));
	});


	jQuery(container + ' .submittal-number').focus();
}

function CopySubmittalBatch(sender) {
	var containerSource = '#' + jQuery(sender).closest('div.submittal-batch-row').attr('id');

	var copyCount = 1;
	try {
		copyCount = parseInt(jQuery(sender).parent().find('input.submittal-batch-copy-number').val());
	} catch (err) {
	}

	if (!copyCount)
		copyCount = 1;

	for (var i = 0; i < copyCount; i++)
		CopySubmittalBatchHandler(containerSource);
}

function DeleteSubmittalBatch(sender) {
	jQuery(sender).closest('div.submittal-batch-row').remove();
	submittalBatchRows = jQuery('#submittal-batch-add-form div.submittal-batch-row').toArray();
	if (submittalBatchRows.length == 0)
		BatchAddBlankC();
}

function CopySubmittalBatchHandler(containerSource) {

	submittalBatchDivId++;
	var containerId = "submittal-batch-" + submittalBatchDivId.toString();
	var container = '#' + containerId;

	var addContainer = "<div class='submittal-batch-add'><button type='button' class='submittal-batch-add-blank' onclick='BatchAddBlankC()'>Add Blank Submittal</button>&nbsp;&nbsp;&nbsp;<button type='button' class='submittal-batch-copy' onclick='CopySubmittalBatch(this)'>Copy Submittal</button>&nbsp;<input type='text' class='submittal-batch-copy-number' value='1' />&nbsp;Time(s)<button type='button' class='submittal-batch-delete' onclick='DeleteSubmittalBatch(this);'>Delete</button></div>";
	var newContainer = "<div id='" + containerId + "' class='submittal-batch-row'>" + addContainer + "</div>";
	jQuery('#submittal-batch-add-form').append(newContainer);
	jQuery(container + ' button.submittal-batch-add-blank,' + container + ' button.submittal-batch-copy,' + container + ' button.submittal-batch-delete').button();

	jQuery(container + ' input.submittal-batch-copy-number').spinner({
		min: 1,
		max: 50,
		step: 1
	});

	jQuery(container + ' div.submittal-batch-add').before(submittalTemplates.submittalHeader.jsRenderTemplate.render());
	jQuery(container + ' table.submittal-fields-admin').before(jQuery(container + ' table.submittal-commands'));
	jQuery(container + ' table.submittal-commands button').hide();
	jQuery(container + ' td.submittal-status-label').hide();
	jQuery(container + ' .submittal-received-date').closest('tr').hide();
	jQuery(container + ' .submittal-number').removeClass('required');

	if (submittal.IsGroupsRequired)
		jQuery(container + ' .submittalGroupsRequired').text('*');

	jQuery(container + ' input.submittal-number').val(jQuery(containerSource + ' input.submittal-number').val());

	jQuery(container + ' .submittalGroupIdList').val(jQuery(containerSource + ' .submittalGroupIdList').val());
	jQuery(container + ' .submittalGroups').html(jQuery(containerSource + ' .submittalGroups').html().replaceAll(containerSource, container));
	jQuery(container + ' .addSubmittalGroupsButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		var groupIdList = jQuery(container + ' .submittalGroupIdList').val();
		initSubmittalGroupsDialog(groupIdList, 'submittalinfo', container);
	});

	jQuery(container + ' .submittalAssignedToHidden').val(jQuery(containerSource + ' .submittalAssignedToHidden').val());
	jQuery(container + ' .submittalAssignedTo').html(jQuery(containerSource + ' .submittalAssignedTo').html().replaceAll(containerSource, container));
	jQuery(container + ' .addSubmittalAssignedToButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('assignedto', container);
	});

	jQuery(container + ' .submittalApproverListHidden').val(jQuery(containerSource + ' .submittalApproverListHidden').val());
	jQuery(container + ' .submittalApproverList').html(jQuery(containerSource + ' .submittalApproverList').html().replaceAll(containerSource, container));
	jQuery(container + ' .addSubmittalApproverListButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('approverlist', container);
	});

	jQuery(container + ' .submittalNotifySubmittedListHidden').val(jQuery(containerSource + ' .submittalNotifySubmittedListHidden').val());
	jQuery(container + ' .submittalNotifySubmittedList').html(jQuery(containerSource + ' .submittalNotifySubmittedList').html().replaceAll(containerSource, container));
	jQuery(container + ' .addSubmittalNotifySubmittedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifysubmittedlist', container);
	});

	jQuery(container + ' .submittalNotifyRejectedListHidden').val(jQuery(containerSource + ' .submittalNotifyRejectedListHidden').val());
	jQuery(container + ' .submittalNotifyRejectedList').html(jQuery(containerSource + ' .submittalNotifyRejectedList').html().replaceAll(containerSource, container));
	jQuery(container + ' .addSubmittalNotifyRejectedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifyrejectedlist', container);
	});

	jQuery(container + ' .submittalNotifyApprovedListHidden').val(jQuery(containerSource + ' .submittalNotifyApprovedListHidden').val());
	jQuery(container + ' .submittalNotifyApprovedList').html(jQuery(containerSource + ' .submittalNotifyApprovedList').html().replaceAll(containerSource, container));
	jQuery(container + ' .addSubmittalNotifyApprovedButton').button({
		icons: {
			primary: 'ui-icon-plusthick'
		},
		text: false
	}).off().on('click', function () {
		initSubmittalProjectContactsDialog('notifyapprovedlist', container);
	});

	var itemTypeCheckboxesSource = jQuery(containerSource + ' .submittal-item-types input');
	var itemTypes = [];
	for (var i = 0; i < itemTypeCheckboxesSource.length; i++) {
		if (jQuery(itemTypeCheckboxesSource[i]).prop('checked')) {
			var itemTypeId = jQuery(itemTypeCheckboxesSource[i]).attr('submittalitemtype').substring(jQuery(itemTypeCheckboxesSource[i]).attr('submittalitemtype').lastIndexOf('_') + 1);
			itemTypes.push(parseInt(itemTypeId));
		}
	}

	jQuery(container + ' .submittal-item-types').empty();
	for (var i = 0; i < submittal.ItemTypes.length; i++) {
		var checked = '';
		for (var j = 0; j < itemTypes.length; j++) {
			if (itemTypes[j] == submittal.ItemTypes[i].SubmittalItemTypeId)
				checked = " checked='checked' ";
		}

		var html = "<input type='checkbox' name='itemtype' class='pjq-validate-ignore' submittalitemtype='" + submittal.ItemTypes[i].SubmittalItemTypeId + "' " + checked + " /><label>" + submittal.ItemTypes[i].ItemType + "</label><br />";
		jQuery(container + ' .submittal-item-types').append(html);
	}

	jQuery(container + ' .submittal-item-types input').rules('remove');

	jQuery(container + ' .submittal-created-by').html(submittal.CreatedByDisplay + ' at ' + submittal.CreatedOn);

	jQuery(container + ' .submittal-due-date,' + container + ' .submittal-received-date').mask('99/99/9999', {
		placeholder: " "
	});

	jQuery(container + ' .submittal-due-date,' + container + ' .submittal-received-date').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: function (name, sender) {
			window.validator.element('#' + jQuery(sender).attr('id'));
		}
	});
	jQuery(container + ' .submittal-due-date').val(jQuery(containerSource + ' .submittal-due-date').val());

	// copy the custom field TRs directly from the source container
	jQuery(containerSource + '  .submittal-fields-admin tr.pjq-custom-field').each(function () {
		jQuery(container + '  .submittal-fields-admin').append(jQuery(this)[0].outerHTML);
	});

	// copy custom field data values from source container to destination
	var whichFields = containerSource + " .submittal-fields-admin tbody tr.pjq-custom-field td input[type='text']," + containerSource + " .submittal-fields-admin tbody tr.pjq-custom-field td input.date, " + containerSource + " .submittal-fields-admin tbody tr.pjq-custom-field td span input, " + containerSource + " .submittal-fields-admin tbody tr.pjq-custom-field td select, " + containerSource + " .submittal-fields-admin tbody tr.pjq-custom-field td div, " + containerSource + " .submittal-fields-admin tbody tr.pjq-custom-field td input.pjq-money-field-width, " + containerSource + " .submittal-fields-admin tbody tr.pjq-custom-field td textarea.pjq-textarea-field-width";

	jQuery(whichFields).each(function () {
		var fieldId = jQuery(this).attr('submittalfieldid').substring(jQuery(this).attr('submittalfieldid').lastIndexOf('-') + 1);

		if (jQuery(this).prop('tagName') == 'SELECT') {
			jQuery(container + ' select[submittalfieldid="' + jQuery(this).attr('submittalfieldid') + '"]').val(jQuery(this).val());
		}
		else if (jQuery(this).hasClass('pjq-money-field-width')) {
			jQuery(container + ' input[submittalfieldid="' + jQuery(this).attr('submittalfieldid') + '"]').val(jQuery(this).val());
		}
		else if (jQuery(this).hasClass('pjq-textarea-field-width')) {
			jQuery(container + ' textarea[submittalfieldid="' + jQuery(this).attr('submittalfieldid') + '"]').val(jQuery(this).val());
		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			jQuery("input[type='checkbox']:checked", this).each(function () {
				jQuery(containerSource + " div[submittalfieldid='" + jQuery(this).attr('submittalfieldid') + "'] input[value='" + jQuery(this).val() + "']").prop("checked", true);
			});
		}
		else if (jQuery(this).hasClass('pjq-datetime')) {
			// ignore, it will get picked up by the time field below this case.
		}
		else if (jQuery(this).hasClass('pjq-time-field-width')) {
			jQuery(container + ' input[submittalfieldid="' + jQuery(this).attr('submittalfieldid') + '"]').val(jQuery(this).val());
			jQuery(container + ' input[submittalfieldid="' + jQuery(this).attr('submittalfieldid') + '"]').siblings('.pjq-date-field-width').val(jQuery(this).siblings('.pjq-date-field-width').val());
		}
		else {
			jQuery(container + ' input[submittalfieldid="' + jQuery(this).attr('submittalfieldid') + '"]').val(jQuery(this).val());
		}
	});


	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-date-field-width").each(function () {
		if (!jQuery(this).hasClass('hasDatepicker')) {
			jQuery(this).mask('99/99/9999', {
				placeholder: " "
			});
			jQuery(this).datepicker({
				showOn: "button",
				numberOfMonths: 3,
				showButtonPanel: true,
				buttonImage: "/i/calendar.png",
				buttonImageOnly: true,
				onSelect: function (name, sender) {
					window.validator.element('#' + jQuery(sender).attr('id'));
				}
			});
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-time-field-width").each(function () {
		if (!jQuery(this).hasClass('hasTimepicker')) {
			jQuery(this).timepicker({
				showOn: 'button',
				showPeriod: true,
				button: jQuery(this).siblings('.ui-timepicker-trigger'),
				onSelect: function (name, sender) {
					window.validator.element('#' + jQuery(sender).attr('id'));
				}
			});
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-numeric-field-width").each(function () {
		var minVal = 0;
		if (jQuery(this).attr('min'))
			minVal = parseInt(jQuery(this).attr('min'));
		var maxVal = 2147483647;
		if (jQuery(this).attr('max'))
			maxVal = parseInt(jQuery(this).attr('max'));
		jQuery(this).spinner({
			min: minVal,
			max: maxVal,
			step: 1,
			spin: function (event, ui) {
				window.validator.element('#' + jQuery(this).attr('id'));
				//EnableSave();
			}
		});
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field select.pjq-choice-field-width").each(function () {
		var x = jQuery(this).attr('data-choice-list').split('|||');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			//jQuery(this).find("option[value='"+x[i].trim()+"'], option[text='"+x[i].trim()+"']").attr('selected','selected');
			jQuery(this).find("option[value='" + x[i].trim() + "'], option[text='" + x[i].trim() + "']").prop('selected', true);
			//jQuery(this).find("option[text='"+x[i].trim()+"']").attr('selected','selected');
			jQuery(this).find("option[text='" + x[i].trim() + "']").prop('selected', true);
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field div.pjq-multiple-choice-list").each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("input[value='" + x[i].trim() + "']").prop('checked', true);
		}
	});

	jQuery(container + " .submittal-fields-admin tr.pjq-custom-field input.pjq-money-field-width").each(function () {
		FormatCurrencyHelper(jQuery(this));
	});


	jQuery(container + ' .submittal-number').focus();

}

var submittalBatchRows = [];

function SubmittalSaveBatch() {
	submittalBatchRows = jQuery('#submittal-batch-add-form div.submittal-batch-row').toArray();
	if (submittalBatchRows.length == 0)
		return;

	SubmittalSaveBatchHandler(submittalBatchRows[0]);
}

function SubmittalSaveBatchHandler(row) {
	var container = '#' + jQuery(row).attr('id');

	var itemTypeCheckboxes = jQuery(container + ' .submittal-item-types input');
	var itemTypes = [];
	for (var i = 0; i < itemTypeCheckboxes.length; i++) {
		if (jQuery(itemTypeCheckboxes[i]).prop('checked')) {
			var itemTypeId = jQuery(itemTypeCheckboxes[i]).attr('submittalitemtype').substring(jQuery(itemTypeCheckboxes[i]).attr('submittalitemtype').lastIndexOf('_') + 1);
			itemTypes.push(itemTypeId);
		}
	}

	if (!ValidateSubmittalAdmin(container))
		return;

	submittalCustomFieldList = '';
	var whichFields = container + " .submittal-fields-admin tbody tr.pjq-custom-field td input[type='text']," + container + " .submittal-fields-admin tbody tr.pjq-custom-field td input.date, " + container + " .submittal-fields-admin tbody tr.pjq-custom-field td span input, " + container + " .submittal-fields-admin tbody tr.pjq-custom-field td select, " + container + " .submittal-fields-admin tbody tr.pjq-custom-field td div, " + container + " .submittal-fields-admin tbody tr.pjq-custom-field td input.pjq-money-field-width, " + container + " .submittal-fields-admin tbody tr.pjq-custom-field td textarea.pjq-textarea-field-width";

	jQuery(whichFields).each(function () {
		var fieldId = jQuery(this).attr('submittalfieldid').substring(jQuery(this).attr('submittalfieldid').lastIndexOf('-') + 1);

		if (jQuery(this).prop('tagName') == 'SELECT') {
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}';
			jQuery('option:selected', jQuery(this)).each(function () {
				submittalCustomFieldList = submittalCustomFieldList + jQuery(this).val() + ',';
			});
			if (submittalCustomFieldList.substring(submittalCustomFieldList.length - 1) == ',')
				submittalCustomFieldList = submittalCustomFieldList.substring(0, submittalCustomFieldList.length - 1);
			submittalCustomFieldList = submittalCustomFieldList + '||||';
		}
		else if (jQuery(this).hasClass('pjq-money-field-width')) {
			var money = jQuery(this).val();
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + money + '||||';
		}
		else if (jQuery(this).hasClass('pjq-textarea-field-width')) {
			var textarea = jQuery(this).val();
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + textarea + '||||';
		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}';
			jQuery("input[type='checkbox']:checked", this).each(function () {
				submittalCustomFieldList = submittalCustomFieldList + jQuery(this).val() + ',';
			});
			if (submittalCustomFieldList.substring(submittalCustomFieldList.length - 1) == ',')
				submittalCustomFieldList = submittalCustomFieldList.substring(0, submittalCustomFieldList.length - 1);
			submittalCustomFieldList = submittalCustomFieldList + '||||';
		}
		else if (jQuery(this).hasClass('pjq-datetime')) {
			// ignore, it will get picked up by the time field below this case.
		}
		else if (jQuery(this).hasClass('pjq-time-field-width')) {
			var dtvalue = jQuery(this).siblings('.pjq-date-field-width').val() + ' ' + jQuery(this).val();
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + dtvalue.trim() + '||||';
		}
		else {
			submittalCustomFieldList = submittalCustomFieldList + fieldId + '{|}' + jQuery(this).val() + '||||';
		}
	});
	if (submittalCustomFieldList.length > 0)
		submittalCustomFieldList = submittalCustomFieldList.substring(0, submittalCustomFieldList.length - 4);

	var dueDate = jQuery(container + ' .submittal-due-date').val();

	ShowBusy('Saving...');
	var groupIdList = jQuery(container + ' .submittalGroupIdList').val();
	var assignedTo = jQuery(container + ' .submittalAssignedToHidden').val();
	var approverList = jQuery(container + ' .submittalApproverListHidden').val();
	var notifySubmittedList = jQuery(container + ' .submittalNotifySubmittedListHidden').val();
	var notifyApprovedList = jQuery(container + ' .submittalNotifyApprovedListHidden').val();
	var notifyRejectedList = jQuery(container + ' .submittalNotifyRejectedListHidden').val();

	// remove this row from the batch
	PanteraScript.PanteraScriptService.AddUpdateSubmittalAdmin(pjqSessionId, submittal.SubmittalId, jQuery(container + ' .submittal-number').val(), itemTypes.join(','), groupIdList, parseInt(assignedTo), submittal.BallInCourt, approverList, dueDate, '', submittal.SubmittalStatus, submittal.NotifyNewList, notifySubmittedList, notifyRejectedList, notifyApprovedList, submittal.UploadContext, submittalCustomFieldList, null, SubmittalSaveBatchC, onScriptError);
}

function SubmittalSaveBatchC(response) {
	submittalBatchRows.shift();
	if (submittalBatchRows.length == 0) {
		HideBusy();
		SubmittalCancelButton();
		ReloadSubmittalList();
	}
	else {
		SubmittalSaveBatchHandler(submittalBatchRows[0]);
	}
}

String.prototype.replaceAll = function (search, replacement) {
	var target = this;
	return target.replace(new RegExp(search, 'g'), replacement);
};

function SubmittalRebuildBallInCourtSelect() {
	jQuery('#submittal-header .submittal-ball-in-court-select').empty();
	jQuery('#submittal-header .submittal-ball-in-court-select').append('<option value="">Select...</option>');

	// parse out assignee (if availble) and approver list (if available)
	var optionText = jQuery('#submittal-header .submittalAssignedTo').text();
	var optionValue = jQuery('#submittal-header .submittalAssignedToHidden').val();
	jQuery('#submittal-header .submittal-ball-in-court-select').append('<option value="' + optionValue + '">' + optionText + '</option>');

	var approverIds = jQuery('#submittal-header .submittalApproverListHidden').val().split(',');
	var itemList = jQuery('#submittal-header .submittalApproverList .submittalUserObject');
	for (var i = 0; i < itemList.length; i++) {
		optionText = jQuery(itemList[i]).text().substring(jQuery(itemList[i]).text().indexOf(')') + 1);
		optionValue = approverIds[i].toString();
		jQuery('#submittal-header .submittal-ball-in-court-select').append('<option value="' + optionValue + '">' + optionText + '</option>');
	}

	// select current ball-in-court if found in list.
	jQuery('#submittal-header .submittal-ball-in-court-select').val(submittal.BallInCourt.toString());

	jQuery('#submittal-header .submittal-ball-in-court').hide();
	jQuery('#submittal-header .submittal-ball-in-court-select').show();
}

function SubmittalBallInCourtChanged() {
	if (jQuery('#submittal-header .submittal-ball-in-court-select').val() == submittal.BallInCourt.toString()) {
		jQuery('#submittal-action1, #submittal-action2').button('option', 'disabled', false);
	}
	else {
		jQuery('#submittal-action1, #submittal-action2').button('option', 'disabled', true);
	}
}
